import organization from './organization/ko'
import themeSceneExport from './themeSceneExport/ko'

export default {
    route: {
        Dashboard : '대시보드',
        rt_tt_DMSystem : '장비 관리 시스템',
        rt_tt_MbManage: '메인보드 관리',
        rt_tt_MbControlNew : '(신) PC용 세션 제어',
        rt_tt_MbInfo: '메인보드 정보',
        rt_tt_MbRunRecord : '운영 기록',
        rt_tt_ThemeEdit: '테마 편집',
        rt_tt_ThmSceneEdit: '장면 편집',
        rt_tt_ThmDevEdit: '장비 편집',
        rt_tt_ThmTaskEdit: '작업 편집',
        rt_tt_SystemSetting: '시스템 설정',
        rt_tt_SystemManage: '시스템 관리',
        rt_tt_UserManage: '사용자 관리',
        rt_tt_DevManage: '장비 관리',
        rt_org_management: '조직 관리',
        rt_org_access: '조직 권한',
        rt_org_users: '조직 구성원',
        rt_role_permissions: '역할 및 권한',
        rt_device_resources: '장비 리소스',
        rt_my_boards: '내 메인보드',
        rt_org_boards: '조직 장비',
        rt_platform_boards: '플랫폼 장비 운영',
        rt_org_themes: '조직 테마',
    },
    page: {
        p1_dsh_mb_info : '메인보드 정보',
        p1_dsh_thm_edit : '테마 편집',
        p1_dsh_sys_setting : '시스템 설정',
        p1_dsh_pc_rt_ctl_new : 'PC용 세션 제어',
        p1_dsh_pc_rt_ctl : '메인보드 제어',
        p1_dsh_online : '온라인',
        p1_dsh_tbshop : '온라인 쇼핑몰',
        p1_dsh_help : '지식베이스',
        
        p99_nav_home : '홈으로 돌아가기',
        p99_nav_sivatech : '시바테크',
        p99_nav_logout : '로그아웃',
        p99_sdb_tt_bd : '메인보드',
        p99_sdb_tt_pgs : '구성 다운로드 진행률',
        
        p2_rt2024_lbl_ipt_keyword : '테마 또는 메인보드 이름을 입력하세요',
        p2_rt2024_lbl_live_only : '온라인만 보기',
        p2_rt2024_show_more : '세션 제어 체크한 후, 메인 컨트롤의 추가 정보가 표시되며, 단일 라인 테마의 장면 관리에 적합합니다.',
        p2_rt2024_lbl_wide : '폭넓은',
        p2_rt2024_lbl_idle : '유휴',
        p2_rt2024_lbl_ready : '준비됨',
        p2_rt2024_lbl_running : '실행',
        p2_rt2024_lbl_finished : '끝',
        p2_rt2024_lbl_offline : '오프라인',
        p2_rt2024_lbl_theme : '테마:',
        p2_rt2024_lbl_boot_theme_no_sel : '시작 테마 미선택',
        p2_rt2024_lbl_theme_mgr : '테마 관리',
        p2_rt2024_lbl_no_running_theme : '보드에 실행 중인 테마가 없습니다',
        p2_rt2024_lbl_running_theme : '실행 중인 테마',
        p2_rt2024_lbl_sel_theme : '테마를 선택해 주세요',
        p2_rt2024_lbl_boot_theme : '시작 테마',
        p2_rt2024_btn_exec_theme : '테마 실행',
        p2_rt2024_btn_set_boot_theme : '시작 테마 설정',
        p2_rt2024_msg_please_sel : '선택해 주세요',
        p2_rt2024_msg_sel_correct_theme : '올바른 테마를 선택해 주세요',
        p2_rt2024_msg_setting : '설정 중...',
        p2_rt2024_msg_boot_theme_ok : '시작 테마 설정 성공',
        p2_rt2024_msg_boot_theme_confirm_fail : '컨트롤러가 시작 테마 설정을 확인하지 못했습니다. 잠시 후 다시 시도해 주세요.',
        p2_rt2024_msg_theme_switching : '테마가 전환되었습니다, 테마 내용을 불러오는 중...',
        p2_rt2024_msg_scene_sync_retry : '장면 데이터 동기화에 실패했습니다. 다시 시도 중...',
        p2_rt2024_msg_scene_sync_fail : '장면 데이터 동기화에 실패했습니다. 네트워크를 확인한 후 테마에 다시 들어가 주세요',
        p2_rt2024_lbl_api_latency : 'API 지연',
        p2_rt2024_lbl_api_latency_fail : '실패',
        p2_rt2024_lbl_api_latency_scene_info : '현재 테마 정보',
        p2_rt2024_lbl_api_latency_theme_list : '테마 목록',
        p2_rt2024_lbl_api_latency_board_info : '보드 정보',
        p2_rt2024_lbl_api_latency_res_config : '리소스 설정',
        p2_rt2024_lbl_api_latency_int_param : '실행 파라미터',
        p2_rt2024_lbl_api_latency_subdev_info : '장치 정보',
        p2_rt2024_lbl_dev_type : '장치 유형',
        p2_rt2024_lbl_board_type_main : '클라우드 컨트롤러',
        p2_rt2024_lbl_board_type_plus : '클라우드 컨트롤러 Plus',
        p2_rt2024_lbl_board_type_nio : '네트워크 포트 컨트롤러',
        p2_rt2024_lbl_board_type_na : '네트워크 오디오 컨트롤러',
        p2_rt2024_lbl_dev_offline : '오프라인',
        p2_rt2024_lbl_dev_online : '온라인',
        p2_rt2024_lbl_net_dev : '네트워크 장치',
        p2_rt2024_lbl_lang_default : '기본값',
        p2_rt2024_lbl_lang_chi : '중국어(chi)',
        p2_rt2024_lbl_lang_eng : '영어(eng)',
        p2_rt2024_lbl_lang_jpn : '일본어(jpn)',
        p2_rt2024_lbl_lang_kor : '한국어(kor)',
        p2_rt2024_lbl_run_limit_prefix:'실행 가능 기한:',
        p2_rt2024_lbl_loading : '불러오는 중​​',
        p2_rt2024_msg_task_skip_ok:'작업 스킵 성공',
        p2_rt2024_msg_task_skip_fail:'작업 스킵 실패',
        p2_rt2024_msg_skip_ok : '스킵 성공',
        p2_rt2024_msg_scene_jump_ok : '씬 점프 성공',
        p2_rt2024_msg_scene_jump_fail : '씬 점프 실패',
        p2_rt2024_msg_scene_trig_ok : '씬 효과 트리거 성공',
        p2_rt2024_msg_scene_trig_fail : '씬 효과 트리거 실패',
        p2_rt2024_msg_task_op_ok : '태스크 제어 성공',
        p2_rt2024_msg_task_op_fail : '태스크 제어 실패',
        p2_rt2024_msg_operate_ok : '조작 성공',
        p2_rt2024_msg_operate_fail : '조작 실패',
        p2_rt2024_msg_reboot_ok : '장치 재부팅 성공',

        p2_rt2024_btn_ok : '좋아요',
        p2_rt2024_btn_cancel : '취소',
        p2_rt2024_cfm_reboot:'재시작 하시겠습니까?',
        p2_rt2024_btn_reboot : '재시작',
        p2_rt2024_lbl_show_act_t : '활성 작업만 보기',
        p2_rt2024_lbl_refresh : '새로고침',
        p2_rt2024_lbl_theme_flow : '테마흐름',
        p2_rt2024_lbl_ipt_dev_name : '입력 장치 이름',
        p2_rt2024_lbl_show_finished : '완료됨 표시',
        p2_rt2024_cfm_skip : '관문을 건너뛸까요?',
        p2_rt2024_btn_skip : '관문 넘기기',
        p2_rt2024_dev_operate : '장치 제어',
        p2_rt2024_lbl_number : '순번',
        p2_rt2024_lbl_port : '포트',
        p2_rt2024_lbl_none : '없음',
        p2_rt2024_lbl_name : '이름',
        p2_rt2024_lbl_status : '상태',
        p2_rt2024_lbl_operate : '조작',
        p2_rt2024_lbl_fuzzy_query : '키워드 퍼지 검색 지원',
        p2_rt2024_lbl_effect_trig : '효과 트리거',
        p2_rt2024_lbl_trigger : '트리거',
        p2_rt2024_lbl_process_test : '프로세스 조정',
        p2_rt2024_lbl_port_info : '포트 정보',
        p2_rt2024_lbl_board_setting : '메인메인보드 설정',
        p2_rt2024_lbl_loading : '불러오는 중​​',

        p2_2_rt_c_bpV5_ip : '입력 포트',
        p2_2_rt_c_bpV5_ipb : '입력 포트 보드',
        p2_2_rt_c_bpV5_op : '출력 포트',
        p2_2_rt_c_bpV5_opb : '출력 포트 보드',
        
        p2_3_rt_c_bs_cfgdata : '구성 데이터',
        p2_3_rt_c_bs_pctn : '구매한 작업 수량',
        p2_3_rt_c_bs_actn : '동시 작업 수량',
        p2_3_rt_c_bs_pr_cnt : '구매한 회차',
        p2_3_rt_c_bs_ur_cnt : '이미 실행된 회차',
        p2_3_rt_c_bs_hw_ver : '하드웨어 버전',
        p2_3_rt_c_bs_sw_ver : 'FW 버전',
        p2_3_rt_c_bs_btn_okay : '좋아요',
        p2_3_rt_c_bs_btn_cancel : '취소',
        p2_3_rt_c_bs_confirm_upd : '업그레이드를 확정하시겠습니까?',
        p2_3_rt_c_bs_do_upd : '업그레이드',
        p2_3_rt_c_bs_more : '고급',
        p2_3_rt_c_bs_cfg_addr : '주소 구성',
        p2_3_rt_c_bs_pls_input : '내용을 입력하세요',
        p2_3_rt_c_bs_addr_modify : '주소 수정',
        p2_3_rt_c_bs_thm_update : '테마 업그레이드',
        p2_3_rt_c_bs_fw_addr : '펌웨어 주소',
        p2_3_rt_c_bs_fw_addr_pls_input : '펌웨어 주소를 입력하세요',
        p2_3_rt_c_bs_fw_addr_invalid : '펌웨어 주소는 115자 이하여야 하며 단일 바이트 문자만 사용할 수 있습니다',
        p2_3_rt_c_bs_fw_update : '펌웨어 업그레이드',
        p2_3_rt_c_bs_resource : '자원',
        p2_3_rt_c_bs_vid_mode : '비디오 모드',
        p2_3_rt_c_bs_v_cont_ud_str : '파일은 셋톱박스 USB에 있습니다.',
        p2_3_rt_c_bs_local : '현지',
        p2_3_rt_c_bs_v_cont_inet_str : '파일은 인터넷 서버에 있으며, 공공 네트워크 연결이 필요하며 속도가 느립니다.',
        p2_3_rt_c_bs_svr_url : '서버 URL',
        p2_3_rt_c_bs_v_cont_lan_str : '파일은 매장 서버에 있으며 속도가 빠릅니다.',
        p2_3_rt_c_bs_svr_lan_url : '서버(로컬 네트워크 IP)',
        p2_3_rt_c_bs_aud_mode : '오디오 모드',
        p2_3_rt_c_bs_a_cont_ud_str : '파일은 메인 보드의 TF 카드 또는 USB 드라이브에 있습니다.',
        p2_3_rt_c_bs_btn_save : '저장',
        p2_3_rt_c_bs_svr_url : '서버 URL',
        p2_3_rt_c_bs_pls_input_svr_url : '서버 주소를 입력해주세요',
        p2_3_rt_c_bs_svr_lan_ip : '서버 IP 주소',
        p2_3_rt_c_bs_ipt_svr_ip : 'IP 주소를 입력해 주세요.',
        p2_3_rt_c_bs_svr_port : '서버 포트',
        p2_3_rt_c_bs_aud_stb_id : '음향 기기 셋톱박스 ID',
        p2_3_rt_c_bs_param_cfg : '매개변수 설정',
        p2_3_rt_c_bs_detail_rtinfo : '상세 운행 정보',
        p2_3_rt_c_bs_run_mode : '운영 모드',
        p2_3_rt_c_bs_port_mode : '포트 스케줄링 모드',
        p2_3_rt_c_bs_net_dev_man : '네트워크 장비 관리',
        p2_3_rt_c_bs_net_reconn : '네트워크 재연결',
        p2_3_rt_c_bs_nio_feature : '네트워크 포트 특성',
        p2_3_rt_c_bs_btn_update : '수정',
        p2_3_rt_c_bs_lbl_unlimit : '무제한',
        p2_3_rt_c_bs_lbl_unknown : '미집계',
        p2_3_rt_c_bs_lbl_bootcnt : '부팅 횟수',
        p2_3_rt_c_bs_lbl_lang : '언어',
        p2_3_rt_c_bs_lbl_res_code : '리소스 코드',
        p2_3_rt_c_bs_lbl_dev_id : '장치 ID',
        p2_3_rt_c_bs_lbl_play_mode : '재생 모드',
        p2_3_rt_c_bs_lbl_sel_play_mode : '재생 모드를 선택해 주세요',
        p2_3_rt_c_bs_lbl_def_vol : '기본 볼륨',
        p2_3_rt_c_bs_lbl_ext_amp : '외부 앰프',
        p2_3_rt_c_bs_lbl_switch_on : '켜기',
        p2_3_rt_c_bs_lbl_switch_off : '끄기',
        p2_3_rt_c_bs_lbl_audio_ctrl : '오디오 제어',
        p2_3_rt_c_bs_lbl_port_limit : '포트 제한 설정',
        p2_3_rt_c_bs_lbl_limit : '제한',
        p2_3_rt_c_bs_lbl_no_limit : '무제한',
        p2_3_rt_c_bs_lbl_sel_date : '날짜 및 시간 선택',
        p2_3_rt_c_bs_lbl_single_stop : '단일 곡 정지',
        p2_3_rt_c_bs_lbl_single_loop : '단일 곡 반복',
        p2_3_rt_c_bs_label_debug : '디버그 정보 등급',
        p2_3_rt_c_bs_cloud_server : '클라우드 서버',
        p2_3_rt_c_bs_admin_param : '관리자 매개변수',
        p2_3_rt_c_bs_run_limit : '실행 시간 제한',
        p2_3_rt_c_bs_msg_fw_done : '업그레이드 완료',
        p2_3_rt_c_bs_msg_fw_start : '업그레이드 시작',
        p2_3_rt_c_bs_msg_fw_fail : '업그레이드 실패',
        p2_3_rt_c_bs_msg_thm_done : '테마 업그레이드 완료',
        p2_3_rt_c_bs_msg_thm_timeout : '테마 업그레이드 시간 초과',
        p2_3_rt_c_bs_msg_thm_start : '테마 업데이트 시작',
        p2_3_rt_c_bs_msg_cfg_ok : '설정이 성공적으로 업데이트되었습니다',
        p2_3_rt_c_bs_msg_cfg1_ok : '설정1이 성공적으로 업데이트되었습니다',
        p2_3_rt_c_bs_msg_cfg2_ok : '설정2가 성공적으로 업데이트되었습니다',
        p2_5_rt_c_bw_lbl_cloud_days : '클라우드 제어 가능 일수',
        p2_5_rt_c_bw_lbl_contact_svc : '만료된 경우 고객센터에 문의하세요',
        p2_5_rt_c_bw_lbl_infinite : '무제한',
        p2_5_rt_c_bw_lbl_expired : '만료',
        p2_5_rt_c_bw_lbl_days : '일',
        p2_5_rt_c_bw_msg_skip_ok : '스킵 성공',
        p2_6_rt_c_tsk_c_lbl_scene_skip_title : '점프할 장면을 선택해 주세요',
        p2_6_rt_c_tsk_c_btn_close : '닫기',
        p2_6_rt_c_tsk_c_btn_confirm : '확인',
        p2_6_rt_c_tsk_c_lbl_assign : '할당',
        p2_6_rt_c_tsk_c_lbl_become : '변화',
        bit_edit_lbl_current_val : '현재 값',
        bit_edit_lbl_input_hint:'정수 입력 (16진수 지원)',
        bit_edit_lbl_decimal_val:'값 (10진수):',
        bit_edit_lbl_hex_val:'값 (16진수):',
        bit_edit_lbl_readonly : '읽기 전용',
        bit_edit_lbl_bit : '비트',
        bit_edit_lbl_bits : '비트 필드',
        bit_edit_lbl_hex : '16진수',
        bit_edit_lbl_dec : '10진수',
        extra_param_desc_debug_level : '디버그 정보 등급 (0-F, 1-E, 2-E, 3-I, 4-V)',
        extra_param_desc_serial_print : '직렬 출력 사용',
        extra_param_desc_action_log_suppression : '동작 중 작업 로그 숨김',
        extra_param_desc_disable_network_log : '네트워크 로그 사용 안 함',
        extra_param_desc_task_end_mode : '작업 종료 모드',
        extra_param_desc_skip_mode : '스킵 모드',
        extra_param_desc_stop_same_port_output : '같은 포트의 출력 장치 중지',
        extra_param_desc_ms_unit : '밀리초 단위',
        extra_param_desc_multi_card_ic_timing : '다중 카드 IC (0) 2ms/(1) 4ms',
        extra_param_desc_remote_control_timing : '리모컨 (0) 8ms/(1) 4ms',
        extra_param_desc_multi_card_gap : '다중 카드 GAP 사용',
        extra_param_desc_nio_input_change_log : 'NIO 입력 포트 변경 로그',
        extra_param_desc_input_port_ll : '입력 포트 LL',
        extra_param_desc_output_port_ll : '출력 포트 LL',
        extra_param_desc_volume_control : '볼륨 제어',
        extra_param_desc_timer_volume_control : '타이머 방식으로 볼륨 제어 전송',
        extra_param_desc_reconnect_count : '연결 끊김 재연결 횟수',
        extra_param_desc_network_discovery_timeout : '네트워크 장치 검색 시간 초과',
        extra_param_desc_sockcomm_no_check : 'sockcomm 응답 검사 안 함',
        extra_param_desc_udp_token_check : '네트워크 포트 보드 UDP 토큰 검사',
        extra_param_desc_udp_sequence_check : '네트워크 포트 보드 UDP 시퀀스 번호 검사',
        extra_param_desc_http_download_optimization : 'HTTP 다운로드 최적화',
        extra_param_desc_networkctrl_tcp_async_send : '비동기 networkctrl TCP 전송',
        extra_param_desc_mobile_network_optimization : '모바일 네트워크 최적화',
        extra_param_desc_networkctrl_tcp_async_drop : '비동기 networkctrl TCP DROP 지원',
        extra_param_desc_input_port_status_log : 'Input 패킷 포트 상태 변경 로그',
        extra_param_desc_retransmission : '재전송 메커니즘',
        extra_param_desc_extradata_crc_check : 'ExtraData CRC 검사',
        extra_param_desc_input_module_limit : '입력 모듈 상한 (0 = 제한 없음)',
        extra_param_desc_output_module_limit : '출력 모듈 상한 (0 = 제한 없음)',
        extra_param_desc_cloud_server : '클라우드 서버 연결 선택 (0~2)',


        p2_4_rt_c_b5_rbt_board : '메인 보드를 재시작하세요',
        p2_4_rt_c_b5_btn_ok:'확인',
        p2_4_rt_c_b5_btn_cancel : '취소',
        p2_4_rt_c_b5_cfm_reboot:'재시작 하시겠습니까?',
        p2_4_rt_c_b5_lbl_idle:'대기',
        p2_4_rt_c_b5_lbl_ready : '준비됨',
        p2_4_rt_c_b5_lbl_running:'실행중',
        p2_4_rt_c_b5_lbl_finished:'종료',
        p2_4_rt_c_b5_lbl_offline : '오프라인',
        p2_4_rt_c_b5_lbl_time : '사용시간',
        p2_4_rt_c_b5_lbl_detail : '상세정보',
        p2_4_rt_c_b5_lbl_inf : '무기한',
        p2_4_rt_c_b5_lbl_outdated : '만료',
        p2_4_rt_c_b5_lbl_day : '날',
        p2_4_rt_c_b5_msg_v_days : '원격 제어 가능 일수:',
        p2_4_rt_c_b5_msg_contact : '기간 만료 시 고객센터에 문의해 주세요.',

        
        p2_5_rt_c_bw_btn_ok : '좋아요',
        p2_5_rt_c_bw_btn_cancel : '취소',
        p2_5_rt_c_bw_cfm_reboot:'재시작 하시겠습니까?',
        p2_5_rt_c_bw_cfm_skip : '메인 미션의 레벨을 건너뛸지 결정하시겠습니까?',
        p2_5_rt_c_bw_lbl_time : '사용시간',
        p2_5_rt_c_bw_scene_skip : '관문 넘기기',
        p2_5_rt_c_bw_lbl_detail : '상세정보',
        
        p2_6_rt_c_tsk_c_lbl_task : '작업',
        p2_6_rt_c_tsk_c_lbl_show_finish : '완료됨 표시',
        p2_6_rt_c_tsk_c_btn_ok : '좋아요',
        p2_6_rt_c_tsk_c_btn_cancel : '취소',
        p2_6_rt_c_tsk_c_cfm_skip : '관문을 건너뛸까요?',
        p2_6_rt_c_tsk_c_btn_skip : '다음 레벨로 넘어가기',
        p2_6_rt_c_tsk_c_msg_skip_ok : '미션 스테이지 클리어 성공',
        p2_6_rt_c_tsk_c_msg_skip_fail : '미션 스테이지 통과 실패',
        p2_6_rt_c_tsk_c_msg_op_success : '임무 제어 성공',
        p2_6_rt_c_tsk_c_msg_op_fail : '임무 제어 실패',
        p2_6_rt_c_tsk_c_msg_scene_lst : '장면 선택',
        p2_6_rt_c_tsk_c_msg_scene_skip_cfm : '장면으로 이동하는 것을 확인합니다.',
        
        p3_te_ztbj_theme_name : '테마 이름',
        p3_te_ztbj_fuzzy_query : '키워드 퍼지 검색 지원',
        p3_te_ztbj_query : '조회',
        p3_te_ztbj_new : '신설',
        p3_te_ztbj_ide_config : 'IDE 구성',
        p3_te_ztbj_show_number : '순번 표시',
        p3_te_ztbj_shs_ipt_list : '동작 바 내부 번호 표시에 체크하세요',
        p3_te_ztbj_auto_name : '자동 이름',
        p3_te_ztbj_show_auto_name : '체크하면 동작 이름에 자동으로 포트 번호가 추가됩니다.',
        p3_te_ztbj_lbl_done : '완료',
        p3_te_ztbj_lbl_edit : '편집',
        p3_te_ztbj_lbl_name : '이름',
        p3_te_ztbj_lbl_description : '설명',
        p3_te_ztbj_resrouce_code : '자원 코드',
        p3_te_ztbj_btn_cancel : '취소',
        p3_te_ztbj_confirm : '확정',
        p3_te_ztbj_btn_share : '공유',
        p3_te_ztbj_pls_ipt_phone : '휴대폰 번호를 입력해 주세요',
        p3_te_ztbj_find : '찾기',
        p3_te_ztbj_btn_backup : '백업',
        p3_te_ztbj_btn_del : '삭제',
        p3_te_ztbj_btn_cooperate : '협업',
        p3_te_ztbj_choose_date : '날짜 선택',
        p3_te_ztbj_own_theme : '자체 테마',
        p3_te_ztbj_coop_theme : '협업 테마',
        p3_te_ztbj_invalid_phone_num : '휴대폰 번호가 올바르지 않습니다.',
        p3_te_ztbj_usr_n_found : '사용자를 찾지 못했습니다',
        p3_te_ztbj_inv_param : '매개변수가 불완전하거나 올바르지 않습니다.',
        p3_te_ztbj_msg_share_success:'공유 성공',
        p3_te_ztbj_msg_share_failed : '공유 실패',
        p3_te_ztbj_coop_success : '협업 성공',
        p3_te_ztbj_coop_fail : '협업 실패',
        p3_te_ztbj_bk_theme_prompt : '현재 테마를 백업하시겠습니까?',
        p3_te_ztbj_prompt : '힌트',
        p3_te_ztbj_bk_success : '백업이 성공적으로 완료되었습니다. 테마 참고사항을 업데이트해주세요. 정보',
        p3_te_ztbj_bk_failed : '백업 실패',
        p3_te_ztbj_cfm_del : '선택한 테마를 삭제하시겠습니까?',
        p3_te_ztbj_del_success : '테마 삭제 성공',
        p3_te_ztbj_dev_fail : '테마 삭제 실패',
        p3_te_ztbj_create_success : '새로운 테마가 성공적으로 추가되었습니다.',
        p3_te_ztbj_mdf_t_info_success : '테마 기본 정보 수정 성공',
        p3_te_ztbj_mdf_t_info_fail : '테마 기본 정보 수정 실패',
        p3_te_ztbj_dev_prop_empty : '장비의 속성이 비어 있습니다. 입력해 주세요.',
        p3_te_ztbj_upd_confirm : '테마 설정을 최신 버전으로 업그레이드하여 더 많은 플레이 방식과 기능을 이용하시겠습니까? 먼저 백업을 한 번 해두는 것이 좋습니다.',
        p3_te_ztbj_chkbar_actbar_empty : 'checkBar 또는 actionBar가 비어 있습니다. 먼저 입력해 주세요.',
        p3_te_ztbj_thm_upd_success : '구성 업그레이드 성공',
        p3_te_ztbj_read_only : '읽기 전용',
        p3_te_ztbj_lbl_owner : '소유자',
        p3_te_ztbj_lbl_mod_time : '수정 시간',
        p3_te_ztbj_lbl_modify : '수정',
        p3_te_ztbj_lbl_dev_edit : '장비 편집',
        p3_te_ztbj_lbl_thm_edit : '장면 편집',
        p3_te_ztbj_lbl_task_edit : '작업 편집',
        p3_te_ztbj_lbl_upd_cfg : '구성 업그레이드',
        p3_te_ztbj_lbl_mgn : '관리',
        p3_te_ztbj_lbl_ver : '버전',
        p3_te_ztbj_share : '테마 공유',
        p3_te_ztbj_coop : '테마 협업',
        p3_te_ztbj_valid_day : '유효 기간(일)',
        p3_te_ztbj_cooper : '협업자',
        p3_te_ztbj_op : '조작',
        p3_te_ztbj_cooperate : '협업',

        
        // p4_lgn_tt_siva_cloud:'Siva-tech 관리시스템',
        p4_lgn_tt_siva_cloud :'Siva-tech 관리시스템',
        p4_lgn_tt_pwd_lgn : '비밀번호 로그인',
        p4_lgn_tt_username : '사용자 이름',
        p4_lgn_tt_passowrd : '비밀번호',
        p4_lgn_tt_login : '로그인',
        p4_lgn_tt_sms_lgn : '문자 메시지 로그인',
        p4_lgn_tt_phone : '휴대폰 번호',
        p4_lgn_cap_pwd_lgn : '인증 코드',
        p4_lgn_tt_sec_to : '초 후 인증번호 받기',
        p4_lgn_tt_veri_code : '인증번호 받기',

        p4_um_title : '사용자 관리',
        p4_um_btn_add_user : '사용자 추가',
        p4_um_filter_username : '사용자 이름 입력',
        p4_um_loading : '로딩 중',
        p4_um_col_no : '번호',
        p4_um_empty_login : '로그인 기록 없음',
        p4_um_col_login_time : '로그인 시간',
        p4_um_col_login_ip : '로그인 IP',
        p4_um_col_client_info : '클라이언트 정보',
        p4_um_col_operation : '작업',
        p4_um_btn_logout_session : '로그아웃',
        p4_um_col_login_name : '로그인명',
        p4_um_col_phone : '휴대폰',
        p4_um_col_nickname : '닉네임',
        p4_um_col_role : '역할',
        p4_um_col_owner : '소속 관리자',
        p4_um_col_status : '상태',
        p4_um_status_normal : '정상',
        p4_um_status_disabled : '비활성',
        p4_um_col_remark : '비고',
        p4_um_btn_edit : '편집',
        p4_um_btn_reset_pwd : '비밀번호 재설정',
        p4_um_btn_delete : '삭제',
        p4_um_dialog_user_info : '사용자 정보',
        p4_um_dialog_user_edit : '사용자 편집',
        p4_um_label_account_role : '계정 역할',
        p4_um_placeholder_role : '계정 역할 선택',
        p4_um_label_owner : '소속 관리자',
        p4_um_placeholder_owner : '소속 관리자 선택',
        p4_um_label_login_name : '로그인명',
        p4_um_label_nickname : '닉네임',
        p4_um_label_password : '로그인 비밀번호',
        p4_um_label_confirm_password : '비밀번호 확인',
        p4_um_label_phone : '휴대폰 번호',
        p4_um_placeholder_country_code : '국가번호',
        p4_um_phone_placeholder : '휴대폰 번호 입력',
        p4_um_placeholder_keep_pwd : '비워두면 기존 비밀번호가 유지됩니다',
        p4_um_label_remark : '비고',
        p4_um_placeholder_remark : '비고 입력',
        p4_um_btn_cancel : '취소',
        p4_um_btn_confirm : '확인',
        p4_um_dialog_delete_title : '삭제 확인',
        p4_um_dialog_delete_msg : '이 사용자를 삭제하시겠습니까? 삭제 후 계정으로 로그인할 수 없습니다.',
        p4_um_role_sivaadmin : '시스템 관리자',
        p4_um_role_subadmin : '서브 관리자',
        p4_um_role_koradmin : '한국 관리자',
        p4_um_role_staff : '내부 직원',
        p4_um_role_user : '일반 사용자',
        p4_um_msg_delete_success : '사용자 삭제 성공',
        p4_um_msg_delete_failed : '사용자 삭제 실패',
        p4_um_msg_login_name_empty : '로그인명이 비어 있습니다',
        p4_um_msg_select_owner : '소속 관리자를 선택하세요',
        p4_um_msg_phone_empty : '휴대폰 번호가 비어 있습니다',
        p4_um_msg_pwd_not_match : '두 비밀번호가 일치하지 않습니다',
        p4_um_msg_pwd_too_short : '비밀번호는 최소 6자 이상이어야 합니다',
        p4_um_msg_update_success : '사용자 수정 성공',
        p4_um_msg_update_failed : '사용자 수정 실패',
        p4_um_msg_add_success : '사용자 추가 성공',
        p4_um_msg_add_failed : '사용자 추가 실패',
        p4_um_msg_session_logout_success : '사용자 로그인 세션 로그아웃 성공',
        p4_um_msg_session_logout_failed : '사용자 로그인 세션 로그아웃 실패',
        
        p5_te_dev_lbl_thm_name : '테마 이름',
        p5_te_dev_lbl_add : '증가',
        p5_te_dev_lbl_finish : '완료',
        p5_te_dev_tt_iogrp_edit : '포트 그룹 편집',
        p5_te_dev_lbl_name : '이름',
        p5_te_dev_lbl_work_mode : '작업 모드',
        p5_te_dev_lbl_pls_choose : '선택해 주세요',
        p5_te_dev_lbl_edit : '편집',
        p5_te_dev_tt_ipt_edit : '입력 포트 편집',
        p5_te_dev_lbl_sec : '초',
        p5_te_dev_tt_opt_edit : '출력 포트 편집',
        p5_te_dev_lbl_ms : '밀리초',
        p5_te_dev_lbl_down_2_brd:'테마 적용',
        p5_te_dev_btn_save : '저장',
        p5_te_dev_btn_push : '발송',
        p5_te_dev_lbl_cfm_push_theme : '테마를 확정하여 발송합니다.',
        p5_te_dev_lbl_2_board : '메인메인보드로',
        p5_te_dev_btn_cancel : '취소',
        p5_te_dev_btn_confirm : '확정',
        p5_te_dev_lbl_thm_id : '테마 ID',
        p5_te_dev_lbl_res_code : '자원 코드',
        p5_te_dev_lbl_svr_mode : '(서버 방식으로 오디오 및 비디오 재생에 사용됨)',
        p5_te_dev_lbl_note : '설명',
        p5_te_dev_btn_theme_list : '기본 정보',
        p5_te_dev_btn_scene_edit : '장면 편집',
        p5_te_dev_tt_dev_order_set : '장비 순서 설정',
        p5_te_dev_btn_new_dev : '새로운 장비',
        p5_te_dev_btn_help : '도움',
        p5_te_dev_btn_order : '정렬',
        p5_te_dev_btn_export : '장비 내보내기',
        p5_te_dev_lbl_loading : '로드 중',
        p5_te_dev_lbl_number : '순번',
        p5_te_dev_lbl_name : '이름',
        p5_te_dev_lbl_dev_edit : '장비 편집',
        p5_te_dev_tt_base_info : '기본 정보',
        p5_te_dev_lbl_note : '설명',
        p5_te_dev_tt_cfg_info : '구성 정보',
        p5_te_dev_tt_dev_export : '장비 정보 내보내기',
        p5_te_dev_lbl_category : '유형',
        p5_te_dev_lbl_netdev : '네트워크 장비',
        p5_te_dev_lbl_port_no : '포트',
        p5_te_dev_lbl_input_port_output : '입력 포트 출력',
        p5_te_dev_hint_input_port_output : '입력 포트 순서대로 각 번호에 1024를 더해 출력 포트를 자동 생성합니다',
        p5_te_dev_lbl_open_port : '시작구',
        p5_te_dev_lbl_close_port : '포트 종료',
        p5_te_dev_lbl_file_no : '파일 번호',
        p5_te_dev_tt_cfm_push : '확정 발송',
        p5_te_dev_lbl_pls_enter : '입력해 주세요',
        p5_te_dev_lbl_ro : '읽기 전용',
        p5_te_dev_btn_do_export : '내보내기',
        p5_te_dev_lbl_pls_sel_bd : '메인메인보드를 선택하세요.',
        p5_te_dev_msg_ro_no_saving : '읽기 전용 모드, 이동 저장 안 함',
        p5_te_dev_msg_empty_condition_err:'현재 장면에 빈 조건/액션 항목이 있습니다. 값을 입력하거나 삭제해 주세요.',
        p5_te_dev_msg_auto_save_ok : '자동 저장 성공',
        p5_te_dev_msg_auto_save_fail : '자동 저장 실패',
        p5_te_dev_msg_brd_lst_refresh : '메인메인보드 목록이 갱신되었습니다.',
        p5_te_dev_msg_fail_obt_blist : '메인메인보드 목록 가져오기 실패',
        p5_te_dev_msg_cp_success : '복사 성공',
        p5_te_dev_msg_cp_scn_first : '먼저 장면을 복사해 주세요.',
        p5_te_dev_msg_paste_ok : '붙여넣기 성공',
        p5_te_dev_msg_empty_list : '목록이 비어 있습니다.',
        p5_te_dev_msg_cfg_del_scn : '해당 장면을 삭제하시겠습니까?',
        p5_te_dev_lbl_pinyin_search : '병음 검색 지원',
        p5_te_dev_lbl_total : '총',
        p5_te_dev_lbl_devices : '개 장비',
        p5_te_dev_msg_port_limit : '추가 실패: 수량이 상한에 도달했습니다',
        p5_te_dev_msg_dup_netdev_id : '네트워크 장비 ID가 중복되었습니다',
        p5_te_dev_msg_issue_auth_expired : '발송 실패: 클라우드 플랫폼 권한이 만료되었습니다',
        p5_te_dev_msg_issue_started : '구성 다운로드를 시작했습니다',
        p5_te_dev_msg_issue_fail : '발송 실패:',
        p5_te_dev_cfm_del_sel_dev : '선택한 장비를 삭제하시겠습니까?',
        p5_te_dev_msg_del_dev_success : '장비 삭제 성공',
        p5_te_dev_msg_del_dev_used : '장면 편집기에서 사용 중인 장비라 삭제할 수 없습니다',
        p5_te_dev_msg_del_dev_fail : '장비 삭제 실패',
        p5_te_dev_lbl_device_manager : '장비 관리',
        p5_te_dev_lbl_device_summary : '구성 요약',
        
        p6_te_scn_lbl_dev_edit : '장비 편집',
        p6_te_scn_lbl_new_scn : '장면 추가',
        p6_te_scn_lbl_dev_name : '장비 이름',
        p6_te_scn_lbl_entr_kw : '이름을 선택하세요',
        p6_te_scn_btn_search : '찾기',
        p6_te_scn_btn_export : '내보내기',
        p6_te_scn_btn_export_xmind : '마인드맵 내보내기',
        p6_te_scn_lbl_next_scn:'다음 장면',
        p6_te_scn_lbl_delay_check:'딜레이 시간(초)',
        p6_te_scn_lbl_tae : '시간 초과 음향',
        p6_te_scn_lbl_timeout_sec:'자동 장면 스킵(초)',
        p6_te_scn_lbl_pass_chk_condition : '통과 판정 조건',
        p6_te_scn_lbl_pass_condition : '통과 조건',
        p6_te_scn_lbl_entr_kw2 : '이름을 입력하세요',
        p6_te_scn_lbl_del_condition : '이 조건을 삭제하세요',
        p6_te_scn_lbl_add_check_grp : '조건 그룹 추가',
        p6_te_scn_lbl_add_check_unt : '클리어 판정 조건 추가',
        p6_te_scn_lbl_inprogress_action : '과정 중 동작',
        p6_te_scn_lbl_inprogress_eff : '과정에서의 효과',
        p6_te_scn_lbl_del_effects : '이 효과 삭제하기',
        p6_te_scn_lbl_copy_effects : '이 효과를 복사하세요',
        p6_te_scn_lbl_condition : '조건',
        p6_te_scn_lbl_success : '성공',
        p6_te_scn_lbl_fail : '실패',
        p6_te_scn_lbl_add_inpgs_ca : '증가 과정의 조건 동작',
        p6_te_scn_lbl_paste_inpgs_ca : '복사한 동작 붙여넣기(조건부)',
        p6_te_scn_lbl_onfinish_actions : '관문 동작',
        p6_te_scn_lbl_add_of_a_uc : '클리어 동작 추가(무조건)',
        p6_te_scn_lbl_paste_of_a_uc : '복사한 동작 붙여넣기(조건 없음)',
        p6_te_scn_lbl_of_a_cdt : '관문 조건 액션',
        p6_te_scn_lbl_add_of_a_cdt : '클리어 동작 추가(조건부)',
        p6_te_scn_lbl_cp_action_cdt : '복사한 동작 붙여넣기(조건부)',
        audio_beat_theme_edit: '테마 편집',
        audio_beat_scene_edit: '장면 편집',
        audio_beat_title: '오디오 비트 포인트',
        audio_beat_current_scene: '현재 장면',
        audio_beat_back_to_scene_edit: '장면 편집으로 돌아가기',
        audio_beat_no_audio: '선택한 오디오 없음',
        audio_beat_choose_audio: '오디오 선택',
        audio_beat_pause: '일시정지',
        audio_beat_play: '재생',
        audio_beat_back_to_start: '시작으로 돌아가기',
        audio_beat_timeline: '타임라인',
        audio_beat_zoom_out: '타임라인 축소',
        audio_beat_zoom_in: '타임라인 확대',
        audio_beat_fit_timeline: '맞춤',
        audio_beat_reselect_audio: '다시 선택',
        audio_beat_timeline_heading: '오디오 및 클리어 동작',
        audio_beat_timeline_help: '빈 영역을 드래그해 이동하고, 동작 바를 드래그해 실행 시간을 조정하세요',
        audio_beat_undo_move: '이동 실행 취소',
        audio_beat_redo_move: '이동 다시 실행',
        audio_beat_lock_action_drag: '동작 바 드래그 잠금',
        audio_beat_waveform: '파형',
        audio_beat_action_bars: '클리어 동작 바',
        audio_beat_undo_this_move: '이번 이동 실행 취소',
        audio_beat_action_bar_count: '동작 바 {count}개 | 동작 바 {count}개',
        audio_beat_action_unit_count: '동작 단위 {count}개 | 동작 단위 {count}개',
        audio_beat_add_action_at_time: '현재 시간에 동작 바 추가',
        audio_beat_delete_action_bar: '동작 바 삭제',
        audio_beat_no_action_bars: '동작 바 없음',
        audio_beat_action_bar_edit: '동작 바 편집',
        audio_beat_name: '이름',
        audio_beat_action_bar_name: '동작 바 이름',
        audio_beat_condition: '조건',
        audio_beat_check_action_help: 'CheckAction 실행 조건 편집',
        audio_beat_add_condition_group: '조건 그룹 추가',
        audio_beat_edit_branch: '분기 편집',
        audio_beat_action_units: '동작 단위',
        audio_beat_action_unit_help: '기존 동작 바 편집 및 일괄 추가 기능을 사용합니다',
        audio_beat_select_action_bar: '동작 바를 선택하세요',
        audio_beat_new_action_hint: '새 지연 시간: {time}. 생성 후 타임라인에 동작 바가 표시됩니다.',
        audio_beat_unconditional_action: '무조건 동작 바',
        audio_beat_conditional_action: '조건부 동작 바',
        audio_beat_success: '성공',
        audio_beat_failure: '실패',
        audio_beat_load_failed: '로드 실패',
        audio_beat_loaded: '로드됨',
        audio_beat_please_choose_audio: '오디오 파일을 선택하세요',
        audio_beat_saved_file_unreadable: '로컬에 저장된 오디오 파일을 읽을 수 없습니다. 다시 선택하세요.',
        audio_beat_saved_file_missing: '오디오 파일 "{path}"의 저장된 내용을 찾을 수 없습니다. 다시 선택하세요.',
        audio_beat_local_save_failed: '오디오는 현재 사용할 수 있지만 로컬 저장에 실패했습니다. 다음 진입 시 다시 선택해야 합니다.',
        audio_beat_scene_id_missing: '현재 장면에 고유 ID가 없어 오디오를 다음에 복원할 수 없습니다.',
        audio_beat_load_error: '오디오 로드 실패: 파일이 없거나 지원되지 않거나 손상되었습니다. 다시 선택하세요.',
        audio_beat_play_error: '오디오 재생에 실패했습니다. 오디오 파일을 다시 선택하세요.',
        audio_beat_default_action_name: '동작 바 {number}',
        audio_beat_action_bar: '동작 바',
        audio_beat_keep_one_condition_group: '조건 그룹을 하나 이상 유지하세요',
        audio_beat_action_limit: '클리어 동작 바 수가 제한({limit}개)을 초과했습니다.',
        audio_beat_move_time: '시간: {from} → {to}',
        audio_beat_select_scene_first: '먼저 장면을 선택하세요',
        p6_te_scn_lbl_desc_txt : '설명 텍스트',
        p6_te_scn_txt_cpoy_of : ' -사본',
        p6_te_scn_msg_manual_save_ok : '수동 저장 성공',
        p6_te_scn_msg_manual_save_fail : '수동 저장 실패',
        p6_te_scn_msg_last_no_del : '마지막 열은 삭제할 수 없습니다.',
        p6_te_scn_lbl_and : '및',
        p6_te_scn_lbl_or : '또는',        
        p6_te_scn_lbl_add_au : '새로운 액션 유닛',
        p6_te_scn_lbl_mod_au : '동작 단위 수정',
        p6_te_scn_lbl_param : '매개변수',
        p6_te_scn_lbl_batch_add_au : '일괄 동작 추가',
        p6_te_scn_lbl_cp_al : '액션 바 복사',
        p6_te_scn_lbl_dev_cate : '장비 카테고리',
        p6_te_scn_lbl_action : '액션',
        p6_te_scn_msg_pls_sel_a : '동작을 선택하세요',
        p6_te_scn_lbl_add_lu : '새로운 논리 단위',
        p6_te_scn_lbl_mod_lu : '논리 단위 수정',
        p6_te_scn_lbl_pass_con2 : '통과 판정:',
        p6_te_scn_lbl_of_actions2 : '동작 완료:',
        p6_te_scn_lbl_remove : '제거하다',
        p6_te_scn_lbl_add_to : '증가',
        p6_te_scn_lbl_tbs : '사용 가능',
        p6_te_scn_lbl_seled : '선택됨',
        p6_te_scn_lbl_batch_add : '일괄 추가',
        p6_te_scn_lbl_pls_chs_or_keywd : '키워드를 선택하거나 입력해 주세요.',
        p6_te_scn_lbl_selected : '선택됨',
        p6_te_scn_lbl_ports : '개 포트',
        p6_te_scn_lbl_clear : '비우기',
        p6_te_scn_lbl_port_sel : '포트 선택',
        p6_te_scn_lbl_port_filter_placeholder : '포트 번호나 숫자를 입력해 필터링하세요(예: 1)',
        p6_te_scn_lbl_sel_ports : '선택된 포트',
        p6_te_scn_lbl_clear_2 : '지우기',
        p6_te_scn_lbl_clear_all : '모두 지우기',
        p6_te_scn_lbl_pls_sel_wm : '작업 모드를 선택하세요.',
        p6_te_scn_txt_del_dev : '장치 삭제',
        p6_te_scn_msg_edit_tag_pending : '편집 중인 액션 태그를 먼저 완료해 주세요',
        p6_te_scn_msg_dev_create_success : '장비가 성공적으로 추가되었습니다',
        p6_te_scn_msg_device_not_found : '장비를 찾을 수 없습니다',
        
        p7_te_tsk_lbl_task : '작업',
        p7_te_tsk_lbl_name : '이름:',
        p7_te_tsk_lbl_entry_scn:'시작 장면:',
        p7_te_tsk_lbl_enable : '활성화:',
        p7_te_tsk_lbl_pls_sel_es:'시작 장면을 지정해 주세요.',

        // ===== p8: 시스템 설정 xtsz =====
        p8_xtsz_title : '시스템 설정',
        p8_xtsz_lbl_nickname : '닉네임',
        p8_xtsz_lbl_login_name : '로그인명',
        p8_xtsz_lbl_phone : '전화번호',
        p8_xtsz_lbl_board_name : '메인메인보드명',
        p8_xtsz_lbl_show_limit : '횟수 제한',
        p8_xtsz_lbl_search_name : '이름 검색',
        p8_xtsz_lbl_own_board : '내 메인보드',
        p8_xtsz_lbl_shared_board : '공유받은 메인보드',
        p8_xtsz_lbl_logged_client : '로그인된 클라이언트',
        p8_xtsz_btn_edit : '편집',
        p8_xtsz_btn_search : '찾기',
        p8_xtsz_btn_share : '공유',
        p8_xtsz_btn_rename : '이름변경',
        p8_xtsz_btn_transfer : '이전',
        p8_xtsz_btn_delete : '삭제',
        p8_xtsz_btn_cancel : '취소',
        p8_xtsz_btn_confirm : '확인',
        p8_xtsz_btn_logout : '로그아웃',
        p8_xtsz_dlg_user_info : '사용자 정보',
        p8_xtsz_dlg_login_pwd : '로그인 비밀번호',
        p8_xtsz_dlg_repeat_pwd : '비밀번호 확인',
        p8_xtsz_dlg_board_transfer : '메인메인보드 이전',
        p8_xtsz_dlg_set_share : '공유 설정',
        p8_xtsz_dlg_delete_share : '공유 삭제',
        p8_xtsz_dlg_edit_board : '메인보드 수정',
        p8_xtsz_dlg_board_limit : '메인메인보드 횟수 제한',
        p8_xtsz_col_user : '사용자',
        p8_xtsz_col_phone : '전화',
        p8_xtsz_col_validity : '유효 기간',
        p8_xtsz_col_operation : '조작',
        p8_xtsz_col_name : '이름',
        p8_xtsz_col_uid : 'UID',
        p8_xtsz_col_firmware : '펌웨어',
        p8_xtsz_col_status : '상태',
        p8_xtsz_col_seq : '번호',
        p8_xtsz_col_login_time : '로그인 시간',
        p8_xtsz_col_login_ip : '로그인 IP',
        p8_xtsz_col_client_info : '클라이언트 정보',
        p8_xtsz_ph_area_code : '지역코드',
        p8_xtsz_ph_keyword_query : '키워드 검색',
        p8_xtsz_ph_board_name : '메인메인보드명 입력',
        p8_xtsz_ph_show_limit_hint : '0 = 무제한',
        p8_xtsz_ph_phone_input : '전화번호 입력',
        p8_xtsz_empty_no_share : '아직 공유된 사용자가 없습니다',
        p8_xtsz_empty_no_login : '로그인 기록 없음',
        p8_xtsz_status_online : '온라인',
        p8_xtsz_status_offline : '오프라인',
        p8_xtsz_warn_transfer : '메인보드 이전 후 현재 사용자는 조작할 수 없습니다. 신중하게 진행해 주세요.',
        p8_xtsz_warn_delete_share : '이 사용자에 대한 공유를 삭제하시겠습니까?',
        p8_xtsz_warn_share_limit : '이 장치는 이미 10명 이상의 사용자와 공유되어 있습니다. 먼저 정리하세요.',
        p8_xtsz_msg_no_transfer_user : '이전 대상 사용자 미설정',
        p8_xtsz_msg_transfer_success : '메인메인보드 이전 성공',
        p8_xtsz_msg_operation_failed : '조작 실패',
        p8_xtsz_msg_board_edit_success : '메인메인보드 수정 성공',
        p8_xtsz_msg_limit_set_success : '횟수 제한 설정 성공',
        p8_xtsz_msg_pwd_mismatch : '비밀번호가 일치하지 않습니다',
        p8_xtsz_msg_user_update_success : '사용자 수정 성공',
        p8_xtsz_msg_user_update_failed : '사용자 수정 실패',
        p8_xtsz_msg_phone_format_error : '전화번호 형식 오류',
        p8_xtsz_msg_user_not_found : '사용자를 찾을 수 없습니다',
        p8_xtsz_lbl_user_prefix : '사용자',
        p8_xtsz_msg_no_share_user : '공유 대상 사용자 미설정',
        p8_xtsz_msg_share_success : '공유 성공',
        p8_xtsz_msg_share_cancel_success : '공유 취소 성공',
        p8_xtsz_msg_share_info_updated : '공유 정보 업데이트됨',
        p8_xtsz_msg_get_share_info_failed : '공유 정보 가져오기 실패',
        p8_xtsz_msg_token_remove_success : '사용자 세션 종료',
        p8_xtsz_msg_token_remove_failed : '사용자 세션 종료 실패',
        p8_xtsz_ph_phone_placeholder : '전화번호 입력',

        dn_dt_1 : '포트 그룹',
        dn_dt_2 : '네트워크 장비',
        dn_dt_3 : '입력 포트',
        dn_dt_4 : '출력 포트',
        dn_dt_5 : '출력-문/자물쇠',
        dn_dt_6 : '문',
        dn_dt_7 : '출력-등',
        dn_dt_8 : '사운드 효과',
        dn_dt_9 : '시간 초과 음향',
        dn_dt_10 : '배경음',
        dn_dt_11 : '비디오',
        dn_dt_12 : '사진',
        dn_dt_13 : '온라인 상호작용',
        dn_dt_14 : '카운터',
        dn_dt_30 : '작업',
        dn_dt_31 : '항상 실행',
        dn_dt_32 : '관문 넘기기',
        dn_dt_33 : '네트워크 장비 준비 완료',
        dn_dt_34 : '방 정리가 끝났습니다.',
        dn_dt_35 : '테마 시작',
        dn_dt_36 : '테마 통과',
        dn_dt_39 : '장면 효과',
        dn_dt_40 : '언어 설정',

        dn_dt_1_p1 : '작업 모드',
        dn_dt_1_p2 : '네트워크 모듈',
        dn_dt_1_p3 : '문 열기 포트',
        dh_dt_1_p1 : '외부 모듈: 다기능 버튼 패널, 전화기. 기타: 메인메인보드 포트',
        mn_dt_1_p1 : ['외부 모듈', '순서 버튼', '순서 출력', '박자 출력','입력 병렬', '입력 직렬', '무작위 키', '순환 키', '키 카운트','리듬 판정(노크)', '두더지 모드', '메모리 키', '호흡 램프 세트', '다중 카드 순서 인식','회전 인코더', '디지털 입출력'],


        dn_dt_2_p1 : '검색 모드',
        dn_dt_2_p2 : '네트워크 장비 ID',
        dn_dt_2_p3 : 'IP 주소',
        dn_dt_2_p4 : 'IP 포트',
        mn_dt_2_p1 : ['자동 탐색', 'IP/포트 설정'],
        
        dn_dt_3_p1 : '작업 모드',
        dn_dt_3_p2 : '포트 번호',
        dn_dt_3_p3 : '네트워크 모듈',
        dn_dt_3_p4 : '계수',
        dn_dt_3_p5 : '지연(초)',
        // mn_dt_3_p1 : ['일반', '키 누름', '키 해제', '트리거 카운트', '트리거 카운트(시간 제한)', '누름 지속 시간', '해제 지속 시간', '간헐적 누름 지속 시간', '역방향 신호', '프로세스 리셋', '다중 카드 인식', '원격 수신'],
        mn_dt_3_p1 : ['일반', '키 누름', '키 해제', '트리거 카운트', '트리거 카운트(시간 제한)', '누름 지속 시간', '해제 지속 시간', '간헐적 누름 지속 시간', '역방향 신호', '프로세스 리셋', '다중 카드 인식', '원격 수신','RESERVED','출력 포트 연동','시간 제한 눌림 판정'],

        
        dn_dt_4_p1 : '작업 모드',
        dn_dt_4_p2 : '포트 번호',
        dn_dt_4_p3 : '네트워크 모듈',
        dn_dt_4_p4 : '계수',
        dn_dt_4_p5 : '밝기(낮음)',
        dn_dt_4_p6 : '밝기(높음)',
        dn_dt_4_p7 : '밀리초급 제어',
        dn_dt_4_p8 : '시작 시간',
        dn_dt_4_p9 : '종료 시간',
        dn_dt_4_p10 : '종료 상태',
        mn_dt_4_p1 : ['일반', '루프', '랜덤 루프', '기본 밝기', '점멸', '랜덤 플래시', '호흡 효과', '유지', '상태 따라가기'],
        mn_dt_4_p2 : ['닫다', '열다'],
        
        dn_dt_5_p1 : '작업 모드',
        dn_dt_5_p2 : '네트워크 모듈',
        dn_dt_5_p3 : '문 열기 포트',
        dn_dt_5_p4 : '포트 닫기',
        dn_dt_5_p5 : '여행 시간(초)',
        mn_dt_5_p1 : ['정의되지 않음', '전자기 자물쇠(상시 열림)', '도어클로저(상시 열림)', '푸시로드 모터', '전자기 자물쇠(상시 닫힘)', '도어클로저(상시 닫힘)', '도어클로저 내장 전자기 자물쇠'],
        
        dn_dt_7_p1 : '포트',
        dn_dt_7_p2 : '밝기',
        
        dn_dt_8_p1 : '문서 번호',
        dn_dt_8_p2 : '네트워크 모듈',        
        
        dn_dt_9_p1 : '문서 번호',
        dn_dt_9_p2 : '네트워크 모듈',
        dn_dt_9_p3 : '재생 볼륨',
        
        dn_dt_10_p1 : '문서 번호',
        dn_dt_10_p2 : '네트워크 모듈',
        dn_dt_10_p3 : '재생 볼륨',
        
        dn_dt_11_p1 : '문서 번호',
        dn_dt_11_p2 : '재생 프로토콜',
        dn_dt_11_p3 : '네트워크 모듈',
        dn_dt_11_p4 : '동영상 길이(초)',
        dn_dt_11_p5 : '재생 주소(파일명)',
        dn_dt_11_p6 : '재생 볼륨',
        dn_dt_11_p2_p1 : ['일반(FILE/HTTP)', '실시간 모니터링'],
        dh_dt_11_p1 : 'USB에 저장된 파일 이름',
        dh_dt_11_p2 : '서버에 저장된 파일명',
        
        dn_dt_12_p1 : '문서 번호',
        dn_dt_12_p2 : '네트워크 모듈',
        dn_dt_12_p3 : '재생 주소(파일명)',
        dh_dt_12_p1 : 'USB에 저장된 파일 이름',
        
        dn_dt_13_p1 : '상호작용 섹션 번호',
        dn_dt_13_p2 : '네트워크 모듈',
        
        dn_dt_14_p1 : '작업 모드',
        dn_dt_14_p2 : '네트워크 모듈',
        mn_dt_14_p1 : ['수치','타이머'],
        
        p98_djcfg_sel_itm_local : '로컬 머신',

        
        p97_devcfg_stn_dt_1 : ['실패','성공','','','','','','','','','','','','','','','실행'],
        p97_devcfg_stn_dt_2 : ['오프라인', '온라인'],
        p97_devcfg_stn_dt_3 : ['무효', '유효'],
        p97_devcfg_stn_dt_4 : ['닫기', '열기'],
        p97_devcfg_stn_dt_5 : ['시작', '시작 중', '종료 중', '종료'],
        p97_devcfg_stn_dt_7 : ['닫기', '열기'],
        p97_devcfg_stn_dt_6 : ['닫기', '열기'],
        p97_devcfg_stn_dt_8 : ['정상', '정상'],
        p97_devcfg_stn_dt_10 : ['정지', '재생', '재생', '일시정지'],
        p97_devcfg_stn_dt_11 : ['정지', '재생', '재생', '일시정지'],
        p97_devcfg_stn_dt_12 : ['정지', '재생'],
        p97_devcfg_opn_dt_12_op_0 : '정지',
        p97_devcfg_opn_dt_12_op_1 : '재생',
        p97_devcfg_stn_dt_13 : ['중지', '실행'],
        p97_devcfg_stn_dt_14 : ['중지', '실행'],
        p97_devcfg_opn_dt_1_op_0 : '관',
        p97_devcfg_opn_dt_1_op_1 : '열다',
        p97_devcfg_opn_dt_4_op_0 : '관',
        p97_devcfg_opn_dt_4_op_1 : '열다',
        p97_devcfg_opn_dt_5_op_0 : '열다',
        p97_devcfg_opn_dt_5_op_1 : '관',
        p97_devcfg_opn_dt_7_op_0 : '관',
        p97_devcfg_opn_dt_7_op_1 : '열다',
        p97_devcfg_opn_dt_6_op_0 : '관',
        p97_devcfg_opn_dt_6_op_1 : '열다',
        p97_devcfg_opn_dt_8_op_1 : '재생',
        p97_devcfg_opn_dt_10_op_1 : '재생',
        p97_devcfg_opn_dt_10_op_3 : '일시정지',
        p97_devcfg_opn_dt_10_op_2 : '복구',
        p97_devcfg_opn_dt_10_op_0 : '중지',
        p97_devcfg_opn_dt_11_op_1 : '재생',
        p97_devcfg_opn_dt_11_op_2 : '복구',
        p97_devcfg_opn_dt_11_op_3 : '일시정지',
        p97_devcfg_opn_dt_11_op_0 : '중지',
        p97_devcfg_opn_dt_13_op_1 : '시작',
        p97_devcfg_opn_dt_13_op_0 : '중지',

        dh_dt_1_p12 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_dt_1_p13 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        hc_dt_1 : '<h3>외부 다중 버튼 모듈, 전화기 또는 메인메인보드의 여러 입력/출력 포트</h3><br/> <p><li>동작 모드<ul><li>외부 모듈: 신호1(DA) 포트와 신호2(CK) 포트를 설정해야 합니다<br/>  <ul>   <li>신호1(DA) 포트: 결과 포트</li>   <li>신호2(CK) 포트: 트리거 포트</li>  </ul>  </li><br/> <li>순차 버튼: 메인메인보드 포트를 순서대로 추가(체크)합니다. 이 포트들이 순서대로 트리거되면 포트 그룹이 올바른 신호를 출력합니다</li></br> <li>순차 출력: 출력 포트 목록에 메인메인보드 출력 포트를 순서대로 추가합니다. 이 포트들은 차례대로 켜집니다<br/>  <ul>   <li>시작 포트: 각 포트가 켜져 있는 시간(1 = 0.1초)</li>   <li>정지 포트: 각 포트가 꺼져 있는 시간(1 = 0.1초)</li>   <li>신호1(DA) 포트: 포트 소등 여부 제어, 0 = 소등, 1 = 소등 안 함</li>   <li>신호2(CK) 포트: 반복 제어, 0 = 반복, 1 = 반복 안 함</li>  </ul>  </li></br> <li>입력 병렬: 출력 포트 목록에 메인메인보드 입력 포트를 추가합니다. 이 포트들 중 어느 하나가 트리거되면 포트 그룹이 올바른 신호를 출력합니다</li></br> <li>입력 직렬: 출력 포트 목록에 메인메인보드 입력 포트를 추가합니다. 이 포트들 중 어느 하나가 트리거되면 포트 그룹이 올바른 신호를 출력합니다</li></br> <li>무순서 버튼: 출력 포트 목록에 메인메인보드 입력 포트를 추가합니다. 이 포트들이 모두 트리거된 후 포트 그룹이 올바른 신호를 출력합니다</li></br> <li>순환 버튼: 출력 포트 목록에 메인메인보드 입력 포트를 순서대로 추가합니다. 이 포트들이 순서대로 트리거되면 포트 그룹이 올바른 신호를 출력합니다. 오류 신호는 출력하지 않습니다</li></br> <li>버튼 카운트: 출력 포트 목록에 메인메인보드 입력 포트를 순서대로 추가합니다. 출력 포트 목록에 각 포트를 몇 번 눌러야 하는지 입력합니다</br>  이 포트들이 지정된 횟수만큼 눌린 뒤 포트 그룹이 올바른 신호를 출력합니다.</li></br> <li>호흡등 그룹: 출력 포트 목록에 호흡 효과에 참여할 포트를 추가합니다;</br>  <ul>   <li>호흡 속도: 값이 클수록 호흡이 느려집니다</li>   <li>가장 밝을 때와 가장 어두울 때 머무는 시간</li>   <li>최대 밝기: 조명의 최대 밝기, 1-100</li>  </ul></li></br> <li>다중 카드 순차 인식: 순서대로 감지된 IC 카드 번호를 판정하여, 순서가 맞으면 통과합니다</br>  <ul>   <li>호흡 속도: 값이 클수록 호흡이 느려집니다</li>   <li>가장 밝을 때와 가장 어두울 때 머무는 시간</li>   <li>정답 목록: 순서대로 태그해야 하는 카드 번호를 추가합니다</li>  </ul> </li></br> </li></p>',
        hc_dt_10 : '<h3>배경음</h3><br/> <span>배경음은 재생이 시작된 뒤 반복 재생 모드로 들어가며, 로컬 모드(U 디스크 또는 TF 카드)<br/>와 네트워크 모드(오디오 셋톱박스 경유)를 지원합니다</span> <p><li>파일 번호<ul><li>음향 효과에 대응하는 파일 번호입니다. 파일은 U 디스크 또는 서버에서 번호.mp3 형식으로 이름이 지정됩니다.<br/> 예: 001.mp3, 002.mp3</li><br/> </li></p>',
        hc_dt_11 : '<h3>비디오</h3><br/> <span>비디오는 로컬 모드(셋톱박스에 있는 U 디스크의 비디오 파일 재생)<br/> 와 네트워크 모드(매장 서버의 비디오 파일 재생)를 지원합니다</span>  <li>파일 번호: 로컬 모드에서 U 디스크 안의 비디오에 대응하는 파일 번호입니다. 파일 이름은<br/>    번호.mp4 형식입니다. 예: 001.mp4, 002.mp4</li>  <li>재생 프로토콜  <ul><li>일반: 일반 비디오 파일을 재생합니다</li>  <li>실시간 모니터링: 로컬 네트워크 내 감시 카메라의 실시간 화면을 재생합니다</li>  </ul></li> <li>셋톱박스 번호: 이 비디오를 재생할 셋톱박스를 지정하는 데 사용합니다.</li> <li>비디오 길이: 파일을 재생할 때 재생해야 하는 시간을 지정합니다(파일 자체의 길이보다 짧아야 합니다).</li> <li>재생 주소: 네트워크 모드에서 서버의 비디오 경로입니다. 전체 경로가 다음과 같다면:<br/>http://192.168.1.100/HYZG/videos/001.mp4 여기에 001.mp4를 입력해야 합니다</li>',
        hc_dt_14 : '<h3>카운터</h3><br/> <p><li>값을 저장하며, 수치 계산과 판정에 사용할 수 있습니다<br/></li></p> <p><li>초 단위 타이머로, 초 단위 계시에 사용할 수 있습니다<br/></li></p>',
        hc_dt_2 : '<h3>셋톱박스, 프린터 등</h3><br/> <p><li>검색 모드<ul><li>자동 발견: 내부 장치 발견 프로토콜을 통해 메인메인보드가 속한 테마의 네트워크 장치를 자동으로 찾을 수 있습니다</li><br/> <li>지정 IP 포트: 네트워크 장치의 IP와 포트를 설정합니다</li> </li></p>',
        hc_dt_3 : '<h3>메인보드의 단일 입력 포트</h3><br/> <p><li>동작 모드<ul><li>일반: 포트에 유효한 레벨이 있을 때 트리거됩니다</li><br/> <li>버튼 누름: 버튼을 누를 때 한 번 트리거됩니다</li><br/> <li>버튼 놓기: 버튼을 놓을 때 한 번 트리거됩니다</li><br/> <li>트리거 횟수: 포트가 지정된 횟수만큼 트리거되면 한 번 트리거됩니다</li><br/> <li>누름 지속 시간: 포트가 지정된 시간 동안 계속 트리거된 뒤 한 번 트리거됩니다</li><br/> <li>놓기 지속 시간: 포트가 지정된 시간 동안 계속 트리거되지 않은 뒤 한 번 트리거됩니다</li><br/> <li>반전 신호: 포트에 유효한 레벨이 없을 때 트리거되며, 일반적으로 출력 전자석 잠금 신호를 감지하는 장치에 사용됩니다</li><br/> <li>흐름 리셋: 버튼을 누르면 흐름이 리셋됩니다</li><br/> </li></p>',
        hc_dt_4 : '<h3>메인보드의 단일 출력 포트</h3><br/> <p><li>동작 모드<ul><li>일반: 켜짐 = 릴레이 도통, 꺼짐 = 릴레이 차단</li><br/> <li>반복: 시작 후 릴레이가 지정된 횟수만큼 동작합니다. 각 반복에서 도통 시간과 차단 시간은<br/>“켜짐 지속 시간”과 “꺼짐 지속 시간”으로 설정하고, 횟수는 “카운트”로 설정합니다<br/> 실행이 끝난 뒤의 종료 상태는 켜짐(릴레이 도통) 또는 꺼짐(릴레이 차단)으로 할 수 있으며, “종료 상태”로 설정합니다</li><br/> <li>사전 설정 밝기: V5 하드웨어에서만 유효합니다. 켜짐 = 사전 설정값으로 PWM 출력, 꺼짐 = 완전히 차단</li><br/> <li>점점 켜짐/꺼짐: V5 하드웨어에서만 유효합니다. 켜짐 = 0에서 시작해 사전 설정값까지 점진적으로 증가하며, 변화 시간은 “켜짐 지속 시간”으로 제어합니다<br/>꺼짐 = 사전 설정값에서 완전히 차단될 때까지 점진적으로 감소하며, 변화 시간은 “꺼짐 지속 시간”으로 제어합니다</li><br/> <li>랜덤 점멸: V5 하드웨어 PWM 보드에서만 유효합니다. 켜짐 = 밝기가 무작위로 변하며, 변화 속도는 “켜짐 지속 시간”으로 제어하고, 소등 시간은 “꺼짐 지속 시간”으로 제어합니다<br/>꺼짐 = 즉시 소등</li><br/> <li>호흡 효과: V5 하드웨어 PWM 보드에서만 유효합니다. 켜짐 = 밝기가 균일하게 변하며, 변화 속도는 “켜짐 지속 시간”으로 제어합니다<br/>꺼짐 = 즉시 소등</li><br/> <li>상태 따라가기: 켜짐 = 입력 포트의 상태를 따라가며, 입력 포트 번호는 “카운트”로 지정합니다<br/>꺼짐 = 상태 따라가기를 중지합니다</li><br/> </li></p>',
        hc_dt_5 : '<h3>여러 유형의 문</h3><br/> <p><li>동작 모드<ul><li>전자석 잠금장치(상시 개방): 전자석 잠금장치를 상시 개방 단자에 연결하고 “문 열기 포트”로 제어합니다. 문 닫힘 상태에서는 포트 릴레이가 도통됩니다</li><br/> <li>도어 클로저: “문 열기 포트”로 제어합니다. 문 닫힘 상태에서는 포트 릴레이가 도통됩니다</li><br/> <li>푸시로드 모터: “문 열기 포트”와 “문 닫기 포트”로 제어합니다.  <br/>문 닫힘 상태에서는 문 닫기 포트 릴레이가 “닫힘 지연”초 동안 도통됩니다(지연이 0이면 계속 도통 상태를 유지합니다)  <br/>문 열림 상태에서는 문 열기 포트 릴레이가 “열림 지연”초 동안 도통됩니다(지연이 0이면 계속 도통 상태를 유지합니다)</li><br/> <li>전자석 잠금장치(상시 폐쇄): 전자석 잠금장치를 상시 폐쇄 단자에 연결하고 “문 열기 포트”로 제어합니다. 문 닫힘 상태에서는 포트 릴레이가 차단됩니다</li><br/> <li>전자석 잠금장치가 있는 도어 클로저: 도어 클로저는 “문 열기 포트”로 제어합니다. 문 닫힘 상태에서는 포트 릴레이가 차단됩니다<br/> 전자석 잠금장치는 “문 닫기 포트”로 제어합니다. 문 닫힘 상태에서는 포트 릴레이가 도통됩니다</li><br/> </li></p>',
        hc_dt_7 : '<h3>조명 장치</h3><br/> <p><li>포트 번호<ul><li>조명의 전원은 “포트”로 제어합니다. 조명이 켜질 때 해당 포트의 릴레이가 도통됩니다</li><br/> </li></p>',
        hc_dt_8 : '<h3>음향 효과</h3><br/> <span>음향 효과는 로컬 모드(U 디스크 또는 TF 카드)와 네트워크 모드(오디오 셋톱박스 경유)를 지원합니다</span> <p><li>파일 번호<ul><li>음향 효과에 대응하는 파일 번호입니다. 파일은 U 디스크 또는 서버에서 번호.mp3 형식으로 이름이 지정됩니다.<br/> 예: 001.mp3, 002.mp3</li><br/> </li></p> <p><li>셋톱박스 번호<ul><li>이 음향 효과를 재생할 셋톱박스를 지정하는 데 사용합니다.</li><br/> </li></p>',
        mn_dt_1_p10 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        mn_dt_1_p8 : [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            128
        ],
        dh_ip_w10_count_b0_0 : '연동된 카운터',
        dh_ip_w11_count_b0_0 : '연동된 카운터',
        dh_ip_w2_count_b0_0 : '연동된 카운터',
        dh_ip_w3_count_b0_0 : '이 횟수만큼 눌린 뒤 트리거',
        dh_ip_w4_count_b0_0 : '이 횟수만큼 눌린 뒤 트리거',
        dn_ip_w0_device_io_b0_0 : '포트 번호',
        dn_ip_w1_device_io_b0_0 : '포트 번호',
        dn_ip_w10_count_b0_0 : '카운터',
        dn_ip_w10_device_io_b0_0 : '포트 번호',
        dn_ip_w11_count_b0_0 : '카운터',
        dn_ip_w11_device_io_b0_0 : '포트 번호',
        dn_ip_w2_count_b0_0 : '카운터',
        dn_ip_w2_device_io_b0_0 : '포트 번호',
        dn_ip_w3_count_b0_0 : '누름 횟수',
        dn_ip_w3_device_io_b0_0 : '포트 번호',
        dn_ip_w4_count_b0_0 : '누름 횟수',
        dn_ip_w4_device_io_b0_0 : '포트 번호',
        dn_ip_w4_interval_b0_0 : '시간 제한(초)',
        dn_ip_w5_device_io_b0_0 : '포트 번호',
        dn_ip_w5_interval_b0_0 : '시간 제한(초)',
        dn_ip_w6_device_io_b0_0 : '포트 번호',
        dn_ip_w6_interval_b0_0 : '시간 제한(초)',
        dn_ip_w7_device_io_b0_0 : '포트 번호',
        dn_ip_w7_interval_b0_0 : '시간 제한(초)',
        dn_ip_w8_device_io_b0_0 : '포트 번호',
        dn_ip_w9_device_io_b0_0 : '포트 번호',
        wm_ip_w0 : '일반',
        wm_ip_w1 : '버튼 누름',
        wm_ip_w10 : '다중 카드 인식',
        wm_ip_w11 : '리모컨 수신',
        wm_ip_w2 : '버튼 떼기',
        wm_ip_w3 : '트리거 카운트',
        wm_ip_w4 : '트리거 카운트(시간 제한)',
        wm_ip_w5 : '누름 지속 시간',
        wm_ip_w6 : '놓음 지속 시간',
        wm_ip_w7 : '간헐 누름 지속 시간',
        wm_ip_w8 : '반전 신호',
        wm_ip_w9 : '프로세스 리셋',
        at_iog_w10_result_io_b12_12 : '예',
        at_iog_w2_ck_io_b0_2 : '단회 출력',
        at_iog_w2_ck_io_b3_3 : '켜기',
        at_iog_w2_result_io_b0_0 : '켜진 후 유지',
        dh_iog_w0_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w0_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w1_fail_wait_b0_0 : '실패 후 재시작 대기 시간(쿨다운)',
        dh_iog_w1_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w1_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w1_start_io_b0_2 : '0 일반, 1 단일 버튼, 2 반전 신호',
        dh_iog_w1_start_io_b13_13 : '중복 버튼 제거',
        dh_iog_w1_start_io_b14_15 : '0 사용 안 함; 1 출력 포트 활성 시 버튼 유효; 2 출력 포트 비활성 시 버튼 유효',
        dh_iog_w1_start_io_b3_5 : '0 표시등 없음, 1 누르면 켜짐, 2 누르면 켜진 상태 유지, 3 누르면 꺼짐, 4 누르면 꺼진 상태 유지, 5 누르면 켜진 상태 유지(자동 점등 안 함), 6 누르면 꺼진 상태 유지(자동 점등 안 함)',
        dh_iog_w1_start_io_b6_6 : '모든 버튼 입력을 기다리지 않고 수시로 판정하며, 오류 시 실패 출력',
        dh_iog_w1_start_io_b8_12 : '0 전체 판정; 1-16은 처음 1-16개 버튼만 판정',
        dh_iog_w10_ck_io_b0_7 : '성공 횟수를 기록하는 카운터. 0 없음, 1~255 카운터 번호',
        dh_iog_w10_input_io_list_b0_0 : '버튼 포트 번호',
        dh_iog_w10_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w10_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w10_output_io_list_b0_0 : '버튼 표시등 포트 번호',
        dh_iog_w10_result_io_b11_11 : '실패 후 오류 정보를 출력하고 현재 라운드를 중지',
        dh_iog_w10_result_io_b12_12 : '오류 시 점수 차감 여부. 0 아니요, 1 예',
        dh_iog_w10_start_io_b0_0 : '성공 횟수 누적 여부. 누적하지 않으면 연속 성공해야 통과',
        dh_iog_w10_start_io_b1_5 : '통과에 필요한 성공 횟수(최대 31)',
        dh_iog_w10_start_io_b12_15 : '회차별 점등 수량. 0은 랜덤, 1-15는 최대 수량',
        dh_iog_w10_start_io_b6_11 : '값이 클수록 난이도가 낮음, 최대 60',
        dh_iog_w10_stop_io_b0_4 : '단일 오류 후 점멸. 0은 점멸 없음, 1-30은 점멸 횟수',
        dh_iog_w11_input_io_list_b0_0 : '버튼 포트 번호',
        dh_iog_w11_output_io_list_b0_0 : '버튼 표시등 포트 번호',
        dh_iog_w11_result_io_b8_15 : '실패 후 재시작 간격(초)',
        dh_iog_w11_start_io_b0_5 : '기억해야 할 최대 수량',
        dh_iog_w11_start_io_b11_15 : '문제 사이 소등 시간(0.1-3초)',
        dh_iog_w11_start_io_b6_10 : '각 문제 점등 시간(0.1-3초)',
        dh_iog_w11_stop_io_b0_10 : '최대 답변 시간 제한 1-100초',
        dh_iog_w11_stop_io_b11_13 : '답변 시 버튼이 점등을 따라가는지 여부',
        dh_iog_w11_stop_io_b14_14 : '오류 발생 시 현재 라운드를 즉시 종료하고 실패 출력',
        dh_iog_w12_ck_io_b6_10 : '램프 최대 밝기, 1-100',
        dh_iog_w12_fail_wait_b0_15 : '호흡 속도. 값이 클수록 더 느림',
        dh_iog_w12_output_io_list_b0_0 : '램프 포트 번호',
        dh_iog_w12_result_io_b11_15 : '가장 밝을 때와 가장 어두울 때 유지 시간',
        dh_iog_w13_fail_wait_b0_0 : '실패 후 재시작 대기 시간(쿨다운)',
        dh_iog_w13_input_io_list_b0_0 : 'IC 센서가 연결된 입력 포트(1개만 가능)',
        dh_iog_w13_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w13_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w13_output_io_list_b0_0 : '정답 카드 번호 목록',
        dh_iog_w13_start_io_b13_13 : '중복 카드 번호 제거 여부(매 라운드)',
        dh_iog_w13_start_io_b3_5 : '0 순차 모드, 1 순환 모드',
        dh_iog_w13_start_io_b6_6 : '모든 버튼 입력을 기다리지 않고 수시로 판정하며, 오류 시 실패 출력(순차 모드 전용)',
        dh_iog_w13_start_io_b8_12 : '0 전체 판정; 1-16은 처음 1-16개의 정답만 판정(순차 모드 전용)',
        dh_iog_w14_ck_io_b0_5 : '인코더 펄스가 몇 개 누적되면 값이 한 번 변하는지',
        dh_iog_w14_input_io_list_b0_0 : '센서가 연결된 입력 포트(2개만 가능)',
        dh_iog_w14_output_io_list_b0_0 : '현재 대응 값을 출력 포트로 출력',
        dh_iog_w14_result_io_b0_7 : '0은 미연동, 그 외 값은 카운터 인덱스',
        dh_iog_w14_result_io_b8_15 : '값이 이 수치로 조정되면 성공으로 판정',
        dh_iog_w14_start_io_b0_2 : '0 직접 출력, 1 8421 코드',
        dh_iog_w14_start_io_b3_4 : '값이 끝에 도달하면 반대쪽 끝부터 자동으로 순환',
        dh_iog_w14_start_io_b5_6 : '0 정방향 설치, 1 역방향 설치',
        dh_iog_w14_stop_io_b0_7 : '값이 이 수치로 조정되면 성공으로 판정',
        dh_iog_w15_input_io_list_b0_0 : '입력 포트를 설정하면 입력 포트에서 값을 읽어 출력함',
        dh_iog_w15_output_io_list_b0_0 : '현재 대응 값을 출력 포트로 출력',
        dh_iog_w15_result_io_b0_7 : '0은 미연동, 그 외 값은 카운터 인덱스',
        dh_iog_w15_result_io_b8_15 : '값이 이 수치로 조정되면 성공으로 판정',
        dh_iog_w15_start_io_b0_2 : '0 직접 출력, 1 8421 코드, 2 연속 포트 구간',
        dh_iog_w15_start_io_b3_5 : '입력 포트 읽기 모드: 0 단일 포트 유효, 1 8421 코드',
        dh_iog_w2_fail_wait_b0_0 : '순환 간격 시간',
        dh_iog_w2_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w2_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w2_start_io_b0_0 : '포트가 켜져 있는 시간',
        dh_iog_w2_stop_io_b0_0 : '포트 소등 후 다음 포트가 켜질 때까지의 시간',
        dh_iog_w3_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w3_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w4_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w4_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w5_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w5_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w6_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w6_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w7_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w7_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w7_start_io_b0_2 : '0 일반, 1 단일 버튼, 2 반전 신호',
        dh_iog_w8_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w8_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w8_start_io_b6_8 : '0 무순서, 수량만 판정; 1 순서 있음, 오류 시 자동 재시작; 2 순서 있음, 오류 즉시 출력',
        dh_iog_w9_input_io_list_b0_0 : '하나만 입력',
        dh_iog_w9_on_fail_ae_b0_0 : '실패 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w9_on_success_ae_b0_0 : '성공 시 자동 재생할 음향 효과 번호. 0은 재생 안 함',
        dh_iog_w9_start_io_b0_0 : '연속 두드림 후 간격. 이 시간을 넘으면 다음 구간으로 계산',
        dh_iog_w9_stop_io_b0_0 : '최종 성공 전까지 오류 신호를 출력하지 않음',
        dn_iog_w0_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w0_fail_wait_b0_0 : '실패 대기',
        dn_iog_w0_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w0_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w0_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w0_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w0_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w0_output_io_list_b0_0 : '출력 포트 목록',
        dn_iog_w0_result_io_b1_5 : '결과 포트(신호 1)',
        dn_iog_w0_start_io_b0_0 : '문 열기 포트',
        dn_iog_w0_stop_io_b0_0 : '정지 포트',
        dn_iog_w1_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w1_fail_wait_b0_0 : '실패 대기',
        dn_iog_w1_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w1_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w1_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w1_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w1_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w1_output_io_list_b0_0 : '출력 포트 목록',
        dn_iog_w1_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w1_start_io_b0_2 : '버튼 모드',
        dn_iog_w1_start_io_b13_13 : '중복 제거',
        dn_iog_w1_start_io_b14_15 : '출력 바인딩',
        dn_iog_w1_start_io_b3_5 : '버튼 점등 모드',
        dn_iog_w1_start_io_b6_6 : '지속 판정',
        dn_iog_w1_start_io_b8_12 : '부분 판정',
        dn_iog_w1_stop_io_b0_0 : '입력 포트 목록',
        dn_iog_w10_ck_io_b0_7 : '성공 카운터',
        dn_iog_w10_fail_wait_b0_0 : '자동 재시작 시간',
        dn_iog_w10_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w10_input_io_list_b0_0 : '버튼 포트',
        dn_iog_w10_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w10_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w10_output_io_count_b0_0 : '버튼등 수량',
        dn_iog_w10_output_io_list_b0_0 : '버튼등 포트',
        dn_iog_w10_result_io_b10_10 : '지정 점등 수량',
        dn_iog_w10_result_io_b11_11 : '오류 시 즉시 중지',
        dn_iog_w10_result_io_b12_12 : '오류 시 점수 차감',
        dn_iog_w10_start_io_b0_0 : '성공 누적',
        dn_iog_w10_start_io_b1_5 : '통과 성공 횟수',
        dn_iog_w10_start_io_b12_15 : '문제별 점등 수량',
        dn_iog_w10_start_io_b6_11 : '난이도 계수',
        dn_iog_w10_stop_io_b0_4 : '오류 후 점멸',
        dn_iog_w10_stop_io_b11_15 : '재시작 간격',
        dn_iog_w10_stop_io_b5_9 : '오류 점멸 간격',
        dn_iog_w11_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w11_input_io_list_b0_0 : '버튼 포트',
        dn_iog_w11_output_io_count_b0_0 : '버튼등 수량',
        dn_iog_w11_output_io_list_b0_0 : '버튼등 포트',
        dn_iog_w11_result_io_b8_15 : '재시작 간격',
        dn_iog_w11_start_io_b0_5 : '문제 수',
        dn_iog_w11_start_io_b11_15 : '소등 시간',
        dn_iog_w11_start_io_b6_10 : '점등 시간',
        dn_iog_w11_stop_io_b0_10 : '답변 제한 시간',
        dn_iog_w11_stop_io_b11_13 : '답변 버튼등',
        dn_iog_w11_stop_io_b14_14 : '오류 즉시 출력',
        dn_iog_w12_ck_io_b6_10 : '최대 밝기',
        dn_iog_w12_fail_wait_b0_15 : '호흡 속도',
        dn_iog_w12_output_io_count_b0_0 : '버튼등 수량',
        dn_iog_w12_output_io_list_b0_0 : '램프 포트',
        dn_iog_w12_result_io_b11_15 : '유지 시간',
        dn_iog_w13_fail_wait_b0_0 : '실패 대기',
        dn_iog_w13_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w13_input_io_list_b0_0 : '입력 포트',
        dn_iog_w13_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w13_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w13_output_io_count_b0_0 : '정답 수',
        dn_iog_w13_output_io_list_b0_0 : '정답 목록',
        dn_iog_w13_start_io_b13_13 : '중복 제거',
        dn_iog_w13_start_io_b3_5 : '판정 모드',
        dn_iog_w13_start_io_b6_6 : '순차 모드 지속 판정',
        dn_iog_w13_start_io_b8_12 : '순차 모드 부분 판정',
        dn_iog_w14_ck_io_b0_5 : '단계당 펄스 수',
        dn_iog_w14_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w14_input_io_list_b0_0 : '입력 포트',
        dn_iog_w14_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w14_output_io_list_b0_0 : '출력 포트',
        dn_iog_w14_result_io_b0_7 : '카운터 연동',
        dn_iog_w14_result_io_b8_15 : '예상 결과',
        dn_iog_w14_start_io_b0_2 : '결과 출력 모드',
        dn_iog_w14_start_io_b3_4 : '순환 조정',
        dn_iog_w14_start_io_b5_6 : '센서 방향',
        dn_iog_w14_stop_io_b0_7 : '값 상한',
        dn_iog_w15_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w15_input_io_list_b0_0 : '입력 포트',
        dn_iog_w15_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w15_output_io_list_b0_0 : '출력 포트',
        dn_iog_w15_result_io_b0_7 : '카운터 연동',
        dn_iog_w15_result_io_b8_15 : '예상 결과',
        dn_iog_w15_start_io_b0_2 : '결과 출력 모드',
        dn_iog_w15_start_io_b3_5 : '입력 모드',
        dn_iog_w2_ck_io_b0_2 : '단회 출력 여부',
        dn_iog_w2_ck_io_b3_3 : '랜덤 순서',
        dn_iog_w2_fail_wait_b0_0 : '순환 간격',
        dn_iog_w2_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w2_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w2_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w2_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w2_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w2_output_io_list_b0_0 : '출력 포트 목록',
        dn_iog_w2_result_io_b0_0 : '계속 켜짐 유지',
        dn_iog_w2_start_io_b0_0 : '점등 시간',
        dn_iog_w2_stop_io_b0_0 : '소등 시간',
        dn_iog_w3_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w3_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w3_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w3_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w3_output_io_count_b0_0 : '비트 수',
        dn_iog_w3_output_io_list_b0_0 : '비트 목록',
        dn_iog_w3_result_io_b0_8 : '전체 간격',
        dn_iog_w3_start_io_b0_12 : '포트',
        dn_iog_w3_start_io_b14_14 : '반복 재생',
        dn_iog_w3_stop_io_b0_4 : '점등 시간',
        dn_iog_w3_stop_io_b10_15 : '비트 간격',
        dn_iog_w3_stop_io_b5_9 : '소등 시간',
        dn_iog_w4_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w4_fail_wait_b0_0 : '실패 대기',
        dn_iog_w4_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w4_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w4_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w4_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w4_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w4_output_io_list_b0_0 : '출력 포트 목록',
        dn_iog_w4_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w4_start_io_b0_0 : '문 열기 포트',
        dn_iog_w4_stop_io_b0_0 : '정지 포트',
        dn_iog_w5_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w5_fail_wait_b0_0 : '실패 대기',
        dn_iog_w5_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w5_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w5_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w5_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w5_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w5_output_io_list_b0_0 : '출력 포트 목록',
        dn_iog_w5_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w5_start_io_b0_0 : '문 열기 포트',
        dn_iog_w5_stop_io_b0_0 : '정지 포트',
        dn_iog_w6_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w6_fail_wait_b0_0 : '실패 대기',
        dn_iog_w6_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w6_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w6_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w6_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w6_output_io_count_b0_0 : '출력 포트 수',
        dn_iog_w6_output_io_list_b0_0 : '출력 포트 목록',
        dn_iog_w6_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w6_start_io_b0_0 : '문 열기 포트',
        dn_iog_w6_stop_io_b0_0 : '정지 포트',
        dn_iog_w7_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w7_fail_wait_b0_0 : '실패 대기',
        dn_iog_w7_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w7_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w7_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w7_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w7_output_io_count_b0_0 : '결과 수',
        dn_iog_w7_output_io_list_b0_0 : '결과 목록',
        dn_iog_w7_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w7_start_io_b0_2 : '버튼 모드',
        dn_iog_w7_stop_io_b0_0 : '정지 포트',
        dn_iog_w8_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w8_fail_wait_b0_0 : '실패 대기',
        dn_iog_w8_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w8_input_io_list_b0_0 : '입력 포트 목록',
        dn_iog_w8_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w8_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w8_output_io_count_b0_0 : '결과 수',
        dn_iog_w8_output_io_list_b0_0 : '결과 목록',
        dn_iog_w8_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w8_start_io_b6_8 : '판정 모드',
        dn_iog_w8_stop_io_b0_0 : '정지 포트',
        dn_iog_w9_ck_io_b0_0 : '트리거 포트(신호 2)',
        dn_iog_w9_fail_wait_b0_0 : '자동 재시작 시간',
        dn_iog_w9_input_io_count_b0_0 : '입력 포트 수',
        dn_iog_w9_input_io_list_b0_0 : '입력 포트',
        dn_iog_w9_on_fail_ae_b0_0 : '실패 음향 효과',
        dn_iog_w9_on_success_ae_b0_0 : '성공 음향 효과',
        dn_iog_w9_output_io_count_b0_0 : '리듬 그룹 수',
        dn_iog_w9_output_io_list_b0_0 : '리듬 그룹 목록',
        dn_iog_w9_result_io_b0_0 : '결과 포트(신호 1)',
        dn_iog_w9_start_io_b0_0 : '리듬 구간 간격',
        dn_iog_w9_stop_io_b0_0 : '지속 판정',
        ec_iog_w1_input_io_list : '포트 편집',
        ec_iog_w1_output_io_list : '포트 편집',
        ec_iog_w1_stop_io : '포트 편집',
        ec_iog_w10_input_io_list : '버튼 포트 편집',
        ec_iog_w10_output_io_list : '램프 포트 편집',
        ec_iog_w11_input_io_list : '버튼 포트 편집',
        ec_iog_w11_output_io_list : '램프 포트 편집',
        ec_iog_w12_output_io_list : '램프 포트 편집',
        ec_iog_w13_input_io_list : '포트 편집',
        ec_iog_w13_output_io_list : '포트 편집',
        ec_iog_w14_input_io_list : '포트 편집',
        ec_iog_w14_output_io_list : '포트 편집',
        ec_iog_w15_input_io_list : '포트 편집',
        ec_iog_w15_output_io_list : '포트 편집',
        ec_iog_w2_output_io_list : '포트 편집',
        ec_iog_w5_input_io_list : '포트 편집',
        ec_iog_w6_input_io_list : '포트 편집',
        ec_iog_w7_input_io_list : '포트 편집',
        ec_iog_w7_output_io_list : '포트 편집',
        ec_iog_w8_input_io_list : '포트 편집',
        ec_iog_w8_output_io_list : '결과 편집',
        ec_iog_w9_input_io_list : '포트 편집',
        ec_iog_w9_output_io_list : '결과 편집',
        ec_dt_1_p8 : '포트 편집',
        ei_dt_1_p8 : '포트',
        ev_dt_1_p8 : '포트 번호',
        ec_dt_1_p10 : '포트 편집',
        ei_dt_1_p10 : '포트',
        ev_dt_1_p10 : '포트 번호',
        ei_iog_w1_input_io_list : '포트',
        ei_iog_w1_output_io_list : '포트',
        ei_iog_w1_stop_io : '포트',
        ei_iog_w10_input_io_list : '포트',
        ei_iog_w10_output_io_list : '포트',
        ei_iog_w11_input_io_list : '포트',
        ei_iog_w11_output_io_list : '포트',
        ei_iog_w12_output_io_list : '포트',
        ei_iog_w13_input_io_list : '포트',
        ei_iog_w13_output_io_list : '정답',
        ei_iog_w14_input_io_list : '포트',
        ei_iog_w14_output_io_list : '포트',
        ei_iog_w15_input_io_list : '포트',
        ei_iog_w15_output_io_list : '포트',
        ei_iog_w2_output_io_list : '포트',
        ei_iog_w5_input_io_list : '포트',
        ei_iog_w6_input_io_list : '포트',
        ei_iog_w7_input_io_list : '포트',
        ei_iog_w7_output_io_list : '포트',
        ei_iog_w8_input_io_list : '포트',
        ei_iog_w8_output_io_list : '계수',
        ei_iog_w9_input_io_list : '포트',
        ei_iog_w9_output_io_list : '두드림 횟수',
        ev_iog_w1_input_io_list : '포트 번호',
        ev_iog_w1_output_io_list : '포트 번호',
        ev_iog_w1_stop_io : '포트 번호',
        ev_iog_w10_input_io_list : '포트 번호',
        ev_iog_w10_output_io_list : '포트 번호',
        ev_iog_w11_input_io_list : '포트 번호',
        ev_iog_w11_output_io_list : '포트 번호',
        ev_iog_w12_output_io_list : '포트 번호',
        ev_iog_w13_input_io_list : '포트 번호',
        ev_iog_w13_output_io_list : '정답 카드 번호',
        ev_iog_w14_input_io_list : '포트 번호',
        ev_iog_w14_output_io_list : '포트 번호',
        ev_iog_w15_input_io_list : '포트 번호',
        ev_iog_w15_output_io_list : '포트 번호',
        ev_iog_w2_output_io_list : '포트 번호',
        ev_iog_w5_input_io_list : '포트 번호',
        ev_iog_w6_input_io_list : '포트 번호',
        ev_iog_w7_input_io_list : '포트 번호',
        ev_iog_w7_output_io_list : '포트 번호',
        ev_iog_w8_input_io_list : '포트 번호',
        ev_iog_w8_output_io_list : '누름 횟수',
        ev_iog_w9_input_io_list : '포트 번호',
        ev_iog_w9_output_io_list : '리듬 횟수',
        it_iog_w10_result_io_b12_12 : '아니요',
        it_iog_w2_ck_io_b0_2 : '반복 출력',
        it_iog_w2_ck_io_b3_3 : '사용 안 함',
        it_iog_w2_result_io_b0_0 : '끄고 다음 항목 점등',
        wm_iog_w0 : '외부 모듈',
        wm_iog_w1 : '순차 포트 그룹',
        wm_iog_w10 : '두더지 게임',
        wm_iog_w11 : '메모리 키',
        wm_iog_w12 : '호흡 램프 세트',
        wm_iog_w13 : '다중 카드 순서 인식',
        wm_iog_w14 : '회전 인코더',
        wm_iog_w15 : '디지털 입출력',
        wm_iog_w2 : '순서 출력',
        wm_iog_w3 : '박자 출력',
        wm_iog_w4 : '입력 병렬',
        wm_iog_w5 : '입력 직렬',
        wm_iog_w6 : '무작위 키',
        wm_iog_w7 : '순환 키',
        wm_iog_w8 : '순환 키',
        wm_iog_w9 : '리듬 판정',
        at_op_w1_finish_status_b0_0 : '켜기',
        at_op_w1_ms_ctrl_b0_0 : '밀리초',
        at_op_w2_finish_status_b0_0 : '켜기',
        at_op_w4_finish_status_b0_0 : '켜기',
        at_op_w6_finish_status_b0_0 : '켜기',
        dh_op_w1_count_b0_0 : '이 횟수에 도달하면 반복을 중지하고 포트를 지정된 상태로 유지',
        dh_op_w1_ms_ctrl_b0_0 : '제어 정밀도 단위',
        dh_op_w2_count_b0_0 : '이 횟수에 도달하면 반복을 중지하고 포트를 지정된 상태로 유지',
        dh_op_w3_brightness_b0_0 : '포트가 켜졌을 때의 밝기 값',
        dh_op_w4_brightness_b0_0 : '가장 밝을 때의 밝기 값',
        dh_op_w4_brightness_low_b0_0 : '가장 어두울 때의 밝기 값',
        dh_op_w4_interval1_b0_0 : '밝아지는 시간. 값이 클수록 변화가 느림',
        dh_op_w4_interval2_b0_0 : '어두워지는 시간. 값이 클수록 변화가 느림',
        dh_op_w5_brightness_b0_0 : '가장 밝을 때의 밝기 값',
        dh_op_w5_brightness_low_b0_0 : '가장 어두울 때의 밝기 값',
        dh_op_w5_count_b0_0 : '점멸 시 켜져 있는 비율. 값이 클수록 켜짐 시간이 길어짐',
        dh_op_w5_interval1_b0_0 : '밝기 변화 속도. 값이 클수록 느림',
        dh_op_w5_interval2_b0_0 : '소등 유지 시간. 값이 클수록 길어짐',
        dh_op_w6_brightness_b0_0 : '가장 밝을 때의 밝기 값',
        dh_op_w6_brightness_low_b0_0 : '가장 어두울 때의 밝기 값',
        dh_op_w6_interval1_b0_0 : '밝기 변화 속도. 값이 클수록 느림',
        dh_op_w6_interval2_b0_0 : '가장 밝고 어두운 상태 유지 시간. 값이 클수록 길어짐',
        dh_op_w8_count_b0_0 : '따라갈 입력 포트 번호(1-200)',
        dn_op_w0_device_io_b0_0 : '포트 번호',
        dn_op_w1_count_b0_0 : '반복 횟수',
        dn_op_w1_device_io_b0_0 : '포트 번호',
        dn_op_w1_finish_status_b0_0 : '종료 상태',
        dn_op_w1_interval1_b0_0 : '시작 시간',
        dn_op_w1_interval2_b0_0 : '종료 시간',
        dn_op_w1_ms_ctrl_b0_0 : '밀리초급 제어',
        dn_op_w2_count_b0_0 : '반복 횟수',
        dn_op_w2_device_io_b0_0 : '포트 번호',
        dn_op_w2_finish_status_b0_0 : '종료 상태',
        dn_op_w2_interval1_b0_0 : '시작 시간',
        dn_op_w2_interval2_b0_0 : '종료 시간',
        dn_op_w3_brightness_b0_0 : '밝기',
        dn_op_w3_device_io_b0_0 : '포트 번호',
        dn_op_w4_brightness_b0_0 : '최대 밝기',
        dn_op_w4_brightness_low_b0_0 : '최소 밝기',
        dn_op_w4_device_io_b0_0 : '포트 번호',
        dn_op_w4_finish_status_b0_0 : '종료 상태',
        dn_op_w4_interval1_b0_0 : '밝아지는 시간',
        dn_op_w4_interval2_b0_0 : '어두워지는 시간',
        dn_op_w5_brightness_b0_0 : '최대 밝기',
        dn_op_w5_brightness_low_b0_0 : '최소 밝기',
        dn_op_w5_count_b0_0 : '점멸 간격',
        dn_op_w5_device_io_b0_0 : '포트 번호',
        dn_op_w5_interval1_b0_0 : '변화 속도',
        dn_op_w5_interval2_b0_0 : '소등 지속 시간',
        dn_op_w6_brightness_b0_0 : '최대 밝기',
        dn_op_w6_brightness_low_b0_0 : '최소 밝기',
        dn_op_w6_device_io_b0_0 : '포트 번호',
        dn_op_w6_finish_status_b0_0 : '종료 상태',
        dn_op_w6_interval1_b0_0 : '변화 속도',
        dn_op_w6_interval2_b0_0 : '유지 시간',
        dn_op_w7_device_io_b0_0 : '포트 번호',
        dn_op_w8_count_b0_0 : '입력 포트 따라가기',
        dn_op_w8_device_io_b0_0 : '포트 번호',
        it_op_w1_finish_status_b0_0 : '닫기',
        it_op_w1_ms_ctrl_b0_0 : '초',
        it_op_w2_finish_status_b0_0 : '닫기',
        it_op_w4_finish_status_b0_0 : '닫기',
        it_op_w6_finish_status_b0_0 : '닫기',
        wm_op_w0 : '일반',
        wm_op_w1 : '루프',
        wm_op_w2 : '랜덤 루프',
        wm_op_w3 : '기본 밝기',
        wm_op_w4 : '점멸',
        wm_op_w5 : '랜덤 플래시',
        wm_op_w6 : '호흡 효과',
        wm_op_w7 : '유지',
        wm_op_w8 : '상태 따라가기',
        dh_dt_1_p2 : 'nan',
        dh_dt_1_p3 : '미사용 시 비워 둘 수 있습니다',
        dh_dt_1_p4 : '미사용 시 비워 둘 수 있습니다',
        dh_dt_1_p5 : '외부 모듈 사용 시 신호1이 연결되는 메인보드 포트입니다',
        dn_dt_1_p4 : '정지 포트',
        dn_dt_1_p5 : '결과 포트(신호1)',
        dn_dt_1_p6 : '트리거 포트(신호2)',
        dn_dt_1_p7 : '실패 대기',
        dn_dt_1_p8 : '입력 포트 목록',
        dn_dt_1_p9 : '입력 포트 수',
        dn_dt_1_p10 : '출력 포트 목록',
        dn_dt_1_p11 : '출력 포트 수',
        dn_dt_1_p12 : '실패 음향 효과',
        dn_dt_1_p13 : '성공 음향 효과',
        dn_dt_8_p3 : '재생 음량',

        p4_lgn_tt_country_code : '국가 번호',
        p9_zbxx_col_id : 'ID',
        p9_zbxx_lbl_lang_yue : '광둥어(chs)',
        p9_zbxx_lbl_runtime_info : '운행 정보',
        p9_zbxx_lbl_normal_running : '정상 운행',
        p9_zbxx_lbl_emergency : '비상 모드',
        p9_zbxx_btn_switch : '전환',
        p9_zbxx_lbl_current_theme : '현재:',
        p9_zbxx_lbl_switch_theme : '테마 전환:',
        p9_zbxx_lbl_boot_theme_default : '기본 부팅:',
        p9_zbxx_tab_info_short : '정보',
        p9_zbxx_tab_setting_short : '설정',
        p9_zbxx_tab_port_short : '포트',
        p9_zbxx_lbl_elapsed : '경과 시간',
        p9_zbxx_msg_sel_correct_theme_1_5 : '올바른 테마를 선택하세요(1-5)',
        p9_zbxx_msg_theme_switching_short : '테마 전환 중...',
        p9_zbxx_msg_please_sel_boot_theme : '부팅 테마를 선택하세요',
        p9_zbxx_msg_sel_correct_theme_0_5 : '올바른 테마를 선택하세요(0-5)',
        p9_zbxx_lbl_theme_short : '테마',
        p9_zbxx_lbl_progress : '진행도: 진행률',
        p9_zbxx_lbl_scene_time : '장면 시간:',
        p9_zbxx_lbl_current_scene : '현재 장면',
        p9_zbxx_lbl_not_started : '시작 안 함',
        p9_zbxx_lbl_select_subdev_type : '장치 유형 선택',
        p9_zbxx_lbl_device_offline : '장치 오프라인',
        p9_zbxx_lbl_show_limit_empty : '회차 잔액을 모두 사용했습니다',
        p9_zbxx_lbl_show_limit_low : '회차 잔액이 얼마 남지 않았습니다',
        p9_zbxx_lbl_no_data : '데이터 없음',
        p9_zbxx_cfm_upgrade_theme : '테마를 업그레이드하시겠습니까?',
        p9_zbxx_lbl_same_port_mutex : '동일 포트 상호 배타',
        p9_zbxx_lbl_net_reconnect_try : '네트워크 재연결 시도',
        p9_zbxx_lbl_audio_control_option : '오디오 제어 옵션',
        p9_zbxx_lbl_input_port_module : '입력 포트 모듈',
        p9_zbxx_lbl_output_port_module : '출력 포트 모듈',
        p9_zbxx_lbl_port_status : '포트 상태',
        p9_zbxx_lbl_board_offline : '메인메인보드 오프라인',
        p6_te_scn_lbl_math_add : '더하기',
        p6_te_scn_lbl_math_sub : '빼기',
        p6_te_scn_lbl_math_mul : '곱하기',
        p6_te_scn_lbl_math_div : '나누기',
        p6_te_scn_msg_scene_lst : '장면 목록',
        p9_yxjl_lbl_board : '메인 컨트롤러',
        p9_yxjl_ph_select_board : '메인 컨트롤러를 선택하세요',
        p9_yxjl_col_boot_count : '실행 횟수',
        p9_yxjl_col_date : '날짜',
        p9_yxjl_col_detail : '상세',
        p9_yxjl_btn_export_exec_record : '실행 기록 내보내기',
        p9_yxjl_col_log : '로그',
        p9_yxjl_btn_view : '보기',
        p9_yxjl_btn_download : '다운로드',
        p9_yxjl_col_scene : '장면',
        p9_yxjl_col_scene_name : '장면 이름',
        p9_yxjl_col_enter_time : '시작 시간',
        p9_yxjl_col_leave_time : '종료 시간',
        p9_yxjl_col_duration : '지속 시간',
        p9_yxjl_tab_main_task : '주 작업',
        p9_yxjl_lbl_run_log : '실행 로그',
        p9_yxjl_empty_no_board : '메인 컨트롤러 없음',
        p9_yxjl_unit_hour : '시간',
        p9_yxjl_unit_minute : '분',
        p9_yxjl_unit_second : '초',
        p9_yxjl_msg_download_failed : '다운로드 실패',
        p9_yxjl_msg_log_url_missing : '로그 파일 주소를 가져올 수 없습니다',
        p9_yxjl_sheet_run_record : '운영 기록',
        p9_yxjl_file_exec_record : '실행기록',
        p9_yxjl_file_default : '운영 기록',
        p9_yxjl_msg_export_success : '실행 기록을 다음 파일로 내보냈습니다:',
        p9_yxjl_msg_export_failed : '실행 기록 내보내기에 실패했습니다:',
        p9_yxjl_xlsx_col_time : '시간',
        p9_yxjl_xlsx_col_tick : '타임스탬프',
        p9_yxjl_xlsx_col_device_category : '장치 종류',
        p9_yxjl_xlsx_col_device_index : '장치 인덱스',
        p9_yxjl_xlsx_col_operation_code : '동작 코드',
        p9_yxjl_xlsx_col_parameter : '매개변수',
        p9_yxjl_xlsx_col_operation : '조작',

        // --- action_name i18n keys (an_) ---
        'an_0_1': '시작',
        'an_0_0': '정지',
        'an_1_1': '시작',
        'an_1_0': '정지',
        'an_2_1': '시작',
        'an_2_0': '정지',
        'an_3_1': '시작',
        'an_3_0': '정지',
        'an_4_1': '시작',
        'an_4_0': '정지',
        'an_4_2': '밝기 설정',
        'an_4_11': '상태 반전',
        'an_5_0': '잠금 해제',
        'an_5_1': '잠금',
        'an_5_2': '반전',
        'an_7_1': '켜기',
        'an_7_0': '끄기',
        'an_7_2': '밝기 설정',
        'an_8_1': '재생',
        'an_8_0': '정지',
        'an_8_4': '음량 설정',
        'an_9_0': '정지',
        'an_9_1': '재생',
        'an_10_1': '재생',
        'an_10_0': '정지',
        'an_10_2': '재개',
        'an_10_3': '일시정지',
        'an_10_4': '음량 설정',
        'an_10_5': '우선 재생',
        'an_11_1': '재생',
        'an_11_0': '정지',
        'an_11_2': '재개',
        'an_11_3': '일시정지',
        'an_11_5': '반복 모드',
        'an_12_1': '재생',
        'an_12_2': '재개',
        'an_12_3': '일시정지',
        'an_13_1': '시작',
        'an_13_0': '정지',
        'an_13_2': '재개',
        'an_13_3': '일시정지',
        'an_14_0': '정지',
        'an_14_1': '시작',
        'an_14_2': '할당',
        'an_14_4': '더하기',
        'an_14_5': '빼기',
        'an_14_6': '곱하기',
        'an_14_7': '나누기',
        'an_14_10': '랜덤값 생성',
        'an_14_12': '더하기',
        'an_14_13': '빼기',
        'an_14_14': '곱하기',
        'an_14_15': '나누기',
        'an_30_1': '시작',
        'an_30_0': '정지',
        'an_30_8': '타이머 리셋',
        'an_30_9': '플로우 리셋',
        'an_30_3': '플로우 스킵',
        'an_31_1': '항상 실행',
        'an_33_1': '네트웍 준비',
        'an_32_1': '스킵',
        'an_34_1': '방 정리 완료',
        'an_35_1': '테마 시작',
        'an_36_1': '테마 종료',
        'an_39_1': '장면 효과 트리거',
        'an_40_1': '언어 설정',

        // --- logic_name i18n keys (ln_) ---
        'ln_1_true': '성공',
        'ln_1_false': '실패',
        'ln_2_true': '성공',
        'ln_2_false': '실패',
        'ln_3_true': '유효',
        'ln_3_false': '무효',
        'ln_3_2': '같음',
        'ln_3_3': '초과',
        'ln_3_4': '이상',
        'ln_3_5': '미만',
        'ln_3_6': '이하',
        'ln_3_7': '다름',
        'ln_4_true': '유효',
        'ln_4_false': '무효',
        'ln_5_true': '닫힘',
        'ln_5_false': '열림',
        'ln_6_true': '열림',
        'ln_6_false': '닫힘',
        'ln_7_true': '켜짐',
        'ln_7_false': '꺼짐',
        'ln_8_true': '켜짐',
        'ln_8_false': '꺼짐',
        'ln_9_true': '켜짐',
        'ln_9_false': '꺼짐',
        'ln_10_true': '켜짐',
        'ln_10_false': '꺼짐',
        'ln_11_true': '켜짐',
        'ln_11_false': '꺼짐',
        'ln_12_true': '켜짐',
        'ln_12_false': '꺼짐',
        'ln_13_true': '성공',
        'ln_13_false': '실패',
        'ln_13_2': '이벤트 수신',
        'ln_14_2': '같음',
        'ln_14_3': '초과',
        'ln_14_4': '이상',
        'ln_14_5': '미만',
        'ln_14_6': '이하',
        'ln_14_7': '다름',
        'ln_14_8': '변경됨',
        'ln_31_true' : '항상 성립',
        'ln_33_true' : '준비됨',
        'an_37_1' : '플로우 리셋',
        'an_37_2' : '플로우 일시정지',
        'an_37_3' : '플로우 속도アップ',
        'an_37_4' : '플로우 속도DOWN',

        tn_task_1 : '메인 작업',
        tn_task_2 : '작업 2',
        tn_task_3 : '작업 3',
        tn_task_4 : '작업 4',
        tn_task_5 : '작업 5',
        tn_task_6 : '작업 6',
        tn_task_7 : '작업 7',
        tn_task_8 : '작업 8',
        tn_task_9 : '작업 9',
        tn_task_10 : '작업 10',
        tn_task_11 : '작업 11',
        tn_task_12 : '작업 12',
        tn_task_13 : '작업 13',
        tn_task_14 : '작업 14',
        tn_task_15 : '작업 15',
        tn_task_16 : '작업 16',
        tn_task_17 : '작업 17',
        tn_task_18 : '작업 18',
        tn_task_19 : '작업 19',
        tn_task_20 : '작업 20',
        tn_task_21 : '작업 21',
        tn_task_22 : '작업 22',
        tn_task_23 : '작업 23',
        tn_task_24 : '작업 24',
        tn_task_25 : '작업 25',
        tn_task_26 : '작업 26',
        tn_task_27 : '작업 27',
        tn_task_28 : '작업 28',
        tn_task_29 : '작업 29',
        tn_task_30 : '작업 30',
        tn_task_31 : '작업 31',
        tn_task_32 : '작업 32',
        tn_task_33 : '작업 33',
        tn_task_34 : '작업 34',
        tn_task_35 : '작업 35',
        tn_task_36 : '작업 36',
        tn_task_37 : '작업 37',
        tn_task_38 : '작업 38',
        tn_task_39 : '작업 39',
        tn_task_40 : '작업 40',
        tn_task_41 : '작업 41',
        tn_task_42 : '작업 42',
        tn_task_43 : '작업 43',
        tn_task_44 : '작업 44',
        tn_task_45 : '작업 45',
        tn_task_46 : '작업 46',
        tn_task_47 : '작업 47',
        tn_task_48 : '작업 48',
        tn_task_49 : '작업 49',
        tn_task_50 : '작업 50',
        tn_task_51 : '작업 51',
        tn_task_52 : '작업 52',
        tn_task_53 : '작업 53',
        tn_task_54 : '작업 54',
        tn_task_55 : '작업 55',
        tn_task_56 : '작업 56',
        tn_task_57 : '작업 57',
        tn_task_58 : '작업 58',
        tn_task_59 : '작업 59',
        tn_task_60 : '작업 60',
        tn_task_61 : '작업 61',
        tn_task_62 : '작업 62',
        tn_task_63 : '작업 63',
        tn_task_64 : '작업 64',
        tn_task_65 : '작업 65',
        tn_task_66 : '작업 66',
        tn_task_67 : '작업 67',
        tn_task_68 : '작업 68',
        tn_task_69 : '작업 69',
        tn_task_70 : '작업 70',
        tn_task_71 : '작업 71',
        tn_task_72 : '작업 72',
        tn_task_73 : '작업 73',
        tn_task_74 : '작업 74',
        tn_task_75 : '작업 75',
        tn_task_76 : '작업 76',
        tn_task_77 : '작업 77',
        tn_task_78 : '작업 78',
        tn_task_79 : '작업 79',
        tn_task_80 : '작업 80',
        tn_task_81 : '작업 81',
        tn_task_82 : '작업 82',
        tn_task_83 : '작업 83',
        tn_task_84 : '작업 84',
        tn_task_85 : '작업 85',
        tn_task_86 : '작업 86',
        tn_task_87 : '작업 87',
        tn_task_88 : '작업 88',
        tn_task_89 : '작업 89',
        tn_task_90 : '작업 90',
        tn_task_91 : '작업 91',
        tn_task_92 : '작업 92',
        tn_task_93 : '작업 93',
        tn_task_94 : '작업 94',
        tn_task_95 : '작업 95',
        tn_task_96 : '작업 96',
        tn_task_97 : '작업 97',
        tn_task_98 : '작업 98',
        tn_task_99 : '작업 99',
        tn_task_100 : '작업 100',
        tn_task_101 : '작업 101',
        tn_task_102 : '작업 102',
        tn_task_103 : '작업 103',
        tn_task_104 : '작업 104',
        tn_task_105 : '작업 105',
        tn_task_106 : '작업 106',
        tn_task_107 : '작업 107',
        tn_task_108 : '작업 108',
        tn_task_109 : '작업 109',
        tn_task_110 : '작업 110',
        tn_task_111 : '작업 111',
        tn_task_112 : '작업 112',
        tn_task_113 : '작업 113',
        tn_task_114 : '작업 114',
        tn_task_115 : '작업 115',
        tn_task_116 : '작업 116',
        tn_task_117 : '작업 117',
        tn_task_118 : '작업 118',
        tn_task_119 : '작업 119',
        tn_task_120 : '작업 120',
        tn_task_121 : '작업 121',
        tn_task_122 : '작업 122',
        tn_task_123 : '작업 123',
        tn_task_124 : '작업 124',
        tn_task_125 : '작업 125',
        tn_task_126 : '작업 126',
        tn_task_127 : '작업 127',
        tn_task_128 : '작업 128',




    },
    organization,
    themeSceneExport,
    role: {
        permission : '권한',
    },
    user: {

    },
    title: {

    },

































































































































}
